import * as XLSX from "xlsx";
import React, { useState } from "react";
import { format, isToday, isYesterday } from "date-fns";
import { de, enUS, es, fr, it, ja, pt, zhCN } from "date-fns/locale";
import { forwardRef, useCallback, useEffect, useImperativeHandle, useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import i18n from "../../../../i18.js";
import { v4 as uuidv4 } from "uuid";

import { formatAgoDate } from "../../../../utils/agoDateUtil.js";
import styles from "./ChatView.module.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import emptyImage from "../../assets/ImageEmpty.svg";
import { ReactComponent as Arrow } from "../../assets/BlackDiagonalArrow.svg";
import { ReactComponent as InternetIconChat } from "../../assets/InternetIconChat.svg";
import { ReactComponent as BlackClip } from "../../assets/paperClipBlack.svg";
import { ReactComponent as BlackMicrophone } from "../../assets/paperMicrophone.svg";
import { ReactComponent as AddPlus } from "../../assets/Plus Icon Black.svg";
import { ReactComponent as IconClose } from "../../assets/closeGray.svg";
import { ReactComponent as FileIcon } from "../../assets/fileIcon.svg";
import { ReactComponent as GrayDiagonalArrow } from "../../assets/GrayDiagonalArrow.svg";
import { ReactComponent as ImageIcon } from "../../assets/imageIcon.svg";
import { ReactComponent as SoundOffIcon } from "../../assets/SoundOffIcon.svg";
import { ReactComponent as SoundOnIcon } from "../../assets/SoundOnIcon.svg";
import { ReactComponent as TokenOpenAI } from "../../assets/tokenOpenAI.svg";
import { ReactComponent as ClaudeAnthropic } from "../../assets/claudeAnthropic.svg";
import { ReactComponent as IconArrowDown } from "../../assets/icon-arrow-down.svg";
import { ReactComponent as IconVerify } from "./assets/icon-verify.svg";
import { ReactComponent as IconCancel } from "./assets/icon-cancel.svg";
import { ReactComponent as ArrowUp } from "../../assets/arrowUp.svg";
import { ReactComponent as IconEdit } from "./assets/icon-edit.svg";
// import { ReactComponent as IconVerify } from "./assets/icon-verify.svg";
import { ReactComponent as IconFacturaGPT } from "../../assets/FacturaLogoIconGreen.svg";
import { ReactComponent as PauseIcon } from "../../assets/PauseIcon.svg";
import { ReactComponent as IconAgent } from "./assets/icon-agent.svg";
import { ReactComponent as IconAttach } from "./assets/icon-attach.svg";
import { ReactComponent as IconAutomate } from "./assets/icon-automate.svg";
import { ReactComponent as IconChat } from "./assets/icon-chat.svg";
import { ReactComponent as IconClock } from "./assets/icon-clock.svg";
import { ReactComponent as IconCopy } from "./assets/icon-copy.svg";
import { ReactComponent as IconDelete } from "./assets/icon-delete.svg";
import { ReactComponent as IconDownload } from "./assets/icon-download.svg";
import { ReactComponent as IconEmail } from "./assets/icon-email.svg";
import { ReactComponent as IconField } from "./assets/icon-field.svg";
import { ReactComponent as IconLocation } from "./assets/icon-location.svg";
import { ReactComponent as IconLock } from "./assets/icon-lock.svg";
import { ReactComponent as IconPhone } from "./assets/icon-phone.svg";
import { ReactComponent as IconPlus } from "./assets/icon-plus.svg";
import { ReactComponent as IconPrint } from "./assets/icon-print.svg";
import { ReactComponent as IconSearch } from "./assets/icon-search.svg";
import { ReactComponent as IconSend } from "./assets/icon-send.svg";
import { ReactComponent as IconShare } from "./assets/icon-share.svg";
import { ReactComponent as IconStar } from "./assets/icon-star.svg";
import { ReactComponent as IconTag } from "./assets/icon-tag.svg";
import { ReactComponent as IconView } from "./assets/icon-view.svg";
import { ReactComponent as IconWorld } from "./assets/icon-world.svg";

import MiniProfileModal from "./MiniProfileModal/MiniProfileModal.jsx";
import AutomateDataComponent from "../../components/Automate/utils/automatesJson.js";
import orangeAgentIcon from "../../assets/orangeAgentIcon.svg";
import ModalConnectionGoogle from "../../components/Automate/Components/GmailFormCreateAutomate/ModalAddConnectionGmail.jsx";
import ChatTags from "./ChatTags/ChatTags.jsx";
import FiltersDropdownContainer from "../../components/FiltersDropdownContainer/FiltersDropdownContainer";
import analizeBill from "../../assets/analizeBill.svg";
import ContactsPopup from "../../components/ContactsPopup/ContactsPopup";
import askAssets from "../../assets/askAssets.svg";
import askClient from "../../assets/askClient.svg";
import askDocument from "../../assets/askDocument.svg";
import askHelp from "../../assets/askHelp.svg";
import facturaGPTBlack from "../../assets/facturaGPTBlackIcon.svg";
import facturaGPTWhite from "../../assets/FacturaGPTW.svg";

import Google from "../../../../translation/AutomatesComponent/ch/google.js";
import ScrapingContainer from "./ScrapingContainer/ScrapingContainer.jsx";
import DonutTimer from "./DonutTimer/DonutTimer.jsx";
import CreateApiConnection from "./CreateApiConnection/CreateApiConnection.jsx";
import FloatingMenu from "../../components/FloatingMenu/FloatingMenu.jsx";
import NewAgentComponent from "../../components/NewAgentComponent/NewAgentComponent.jsx";
import AudioWaves from "../../components/AudioWaves/AudioWaves.jsx";
import BtnOPtionsMessage from "./BtnOptionsMessage/BtnOPtionsMessage.jsx";
import Scroller from "./ChatTags/Scroller.jsx";
import SelectAgentModal from "./SelectAgentModal/SelectAgentModal.jsx";
import MessageApi from "./ApiPage/ApiPage.jsx";
import FileExplorer from "./FileExplorer/FileExplorer.jsx";
import FolderIndicator from "./FileExplorer/FolderIndicator.jsx";
import AppIndicator from "./FileExplorer/AppIndicator.jsx";

import { getAutomatesByIds, importData } from "../../../../actions/automate.js";

import {
  fetchByChat,
  fetchByMenu,
  restartLastMessage,
  searchInWebAction,
  validateTokenGPT
} from "../../../../actions/chat.js";

import { setAppFiles } from "../../../../slices/docsSlices";


import { getTokens, updateAccount, updateTokens } from "../../../../actions/user";

import { setShowAutomation, } from "@src/slices/userSlices";

import { setAsset, setFatherNewAsset, setIdFatherNewAsset } from "../../../../slices/assetsSlices.js";
import { setContact, setFatherIdNewContact, setFatherNewContact } from "../../../../slices/contactsSlices.js";
import { setMessageDocsShow, setMessageDocsData, setMessageDocsDocId, setMessageDocsSelectedSection, createAppFile } from "../../../../slices/docsSlices";
import { setEmptyChat } from "../../../../slices/chatSlices.js";
import { languageFlags } from "../../../../utils/flags.js";
import { apiUrl } from "../../../../apiBackend.js";
import { getAgents } from "../../../../actions/agents.js";




import DynamicTable from "../../components/DynamicTable/DynamicTable.jsx";

import mermaid from "mermaid";
mermaid.initialize({
  startOnLoad: true,
  theme: "default",
  securityLevel: "loose",
});




export const ChatBody = ({
  itemsSelected,
  setItemsSelected,
  handleSendMessage,
  showReply,
  setShowReply,
  isLoadBot,
  handleChat,
  messages,
  setMessages,
  inputValue,
  setInputValue,
  userData,
  // showNewAgent,
  // setShowNewAgent,
  isAgentPopup,
  // setUserData,
  hiddeCarousel,
  chatId,
  // setChatAgentId,
  isAgentModal,
  tokenInput,
  tokenOutput,
  timeToFinishResponse,
  proptText,
  autoClear,
  setAutoClear,
  filePayload,
  setFilePayload,
  newChat,
  setNewChat,
  // setContainsArroba,
  containsArroba,
  handleSelectItem,
  windowWidth,
  // currentChat,
  setSearchInWeb,
  searchInWeb,
  setTokenInput,
  setTokenOutput,
  setTimeToFinishResponse,
  showInfoMessage,
  setShowInfoMessage,
  agentId,
  user,
  finishedResponseBot,
  setIsPaused,
  isPaused,
  tokens,
  chatAutomate,
  selectedAutomateChat,
  apiUrl,
  // selectedAgent
}) => {


  const [t] = useTranslation(["ChatView", "Preview"]);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation()

  const {
    selectedAgent, searchTerm: searchTermState
  } = useSelector((state) => state.chat);

  const { selectedSectionId } = useSelector((state) => state.docs.doc);


  const recommendedQuestions = [
    t("recommendedQuestions1"),
    t("recommendedQuestions2"),
    t("recommendedQuestions3"),
    t("recommendedQuestions4"),
    t("recommendedQuestions5"),
    t("recommendedQuestions6"),
    t("recommendedQuestions7"),
    t("recommendedQuestions8"),
    t("recommendedQuestions9"),
    t("recommendedQuestions10"),
    t("recommendedQuestions11"),
    t("recommendedQuestions12"),
    t("recommendedQuestions13"),
    t("recommendedQuestions14"),
    t("recommendedQuestions15"),
  ];

  const imageExtensions = ["png", "jpg", "jpeg", "gif", "bmp", "svg", "webp"];


  const recorderRef = useRef();
  const fileInputRef = useRef(null);
  const textareaRef = useRef(null);
  const chatTextContainerRef = useRef(null);
  const containerRef = useRef(null);
  const dragTimeoutRef = useRef(null);
  const dragCounterRef = useRef(0);
  const dragContainerRef = useRef(null);
  const attachmentAreaRef = useRef(null);
  const dynamicTableRef = useRef(null)

  const [loadingStates, setLoadingStates] = useState([]);

  const [isDropping, setIsDropping] = useState(false);
  const [isDragging, setIsDragging] = useState(false);

  const [fileInfo, setFileInfo] = useState(null);
  const [isFocused, setIsFocused] = useState(false);
  const messageContainerRef = useRef(null);

  const [imageError, setImageError] = useState(false);
  const [scrollTop, setScrollTop] = useState(0);
  const [showMiniProfileModal, setShowMiniProfileModal] = useState()
  const [isTokenValid, setIsTokenValid] = useState("loading");
  const [iniVoice, setIniVoice] = useState(false)


  const [processingTime, setProcessingTime] = useState(0)
  const [showImportAttachment, setShowImportAttachment] = useState(false)
  const [endTime, setEndTime] = useState(30)

  const [muted, setMuted] = useState(() => {
    const stored = localStorage.getItem("mutedSound");
    return stored === null ? true : stored === "true";
  });

  const [lastMessageText, setLastMessageText] = useState('')
  const [lastMessageTime, setLastMessageTime] = useState(0)


  const [selectedAutomate, setSelectedAutomate] = useState(null)
  const [automations, setAutomations] = useState([])

  const [shouldRenderActions, setShouldRenderActions] = useState(false);



  const [showVoiceRecorder, setShowVoiceRecorder] = useState(false);
  const [voiceMessage, setVoiceMessage] = useState(null);
  const [editingVariableIndices, setEditingVariableIndices] = useState([]);
  const [editingVariableValues, setEditingVariableValues] = useState({});


  let lastDateLabel = null;

  const currentLang = i18n.language;
  const locales = {
    English: enUS,
    Español: es,
    Français: fr,
    Português: pt,
    Deutsch: de,
    Italiano: it,
    日本語: ja,
    中文: zhCN,
  };


  const [events, setEvents] = useState([{
    default: 'Escaneando el archivo..',
    title: 'Se esta procesando el archivo',
    description: '{size} - {name}',
    type: 'upload',
    data: {
      size: null,
      name: null,
      extension: null,
      time: 0
    }
  }, {
    default: 'Cargando automatización..',
    title: 'Leyendo la automatización de {name}',
    description: '{timestamp} fue creada',
    type: 'automate',
    data: {
      id: null,
      name: null,
      type: null,
      timestamp: null,
      time: 0
    }
  }, {
    default: 'Se extraeran los datos del documento',
    title: 'Extrayendo información de {type}',
    description: '{parameters} parámetros detectados',
    type: 'extract',
    data: {
      parameters: null,
      type: null,
      time: 0
    }
  }, {
    default: 'Se importaran la información recibida',
    title: 'Se han detectado estos datos',
    description: '{contacts} contactos - {actives} activos - {documents} documento',
    type: 'import',
    data: {
      contacts: null,
      actives: null,
      documents: null,
      repeatData: null,
      time: 0
    }
  }, {
    default: 'Esperando a completar la automatización',
    title: 'Generando reporte',
    description: '{percent}% de la información fue procesada',
    type: 'report',
    data: {
      percent: null,
      time: 0
    }
  }])


  // const groupedMessages = messages.reduce((acc, message) => {
  //   let dateKey;
  //   try {
  //     const dateObj = new Date(message.timestamp);
  //     if (isNaN(dateObj.getTime())) throw new Error("Invalid date");
  //     dateKey = dateObj.toISOString().slice(0, 10);
  //   } catch {
  //     dateKey = new Date().toISOString().slice(0, 10);
  //   }

  //   if (!acc[dateKey]) acc[dateKey] = [];
  //   acc[dateKey].push(message);
  //   return acc;
  // }, {});
  // const locale = locales[currentLang] || locales['English'];




  const [voiceChat, setVoiceChat] = useState(false);
  const [finalTranscript, setFinalTranscript] = useState("");
  const [countdownNumber, setCountdownNumber] = useState(null);
  // const [shouldSendTranscript, setShouldSendTranscript] = useState(false);
  const finalTranscriptRef = useRef("");
  // const countdownNumberRef = useRef(5);
  const recognitionRefAudio = useRef(null);
  const countdownRef = useRef(null);



  const [messageHistory, setMessageHistory] = useState([]);
  const [historyIndex, setHistoryIndex] = useState(-1);
  const [isNavigatingHistory, setIsNavigatingHistory] = useState(false);


  const [hasStoppedRecording, setHasStoppedRecording] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isRecording, setIsRecording] = useState(false);



  const scrollContainerRef = useRef(null);

  // const combinedRef = (el) => {
  //   messageContainerRef.current = el;
  //   scrollContainerRef.current = el;
  // };


  const [activeDateLabel, setActiveDateLabel] = useState(null);
  const observerRefs = useRef({});
  const dateLabelRefs = useRef({});



  let options = [
    {
      name: t('tokenOpenAI'),
      label: <> <TokenOpenAI height={20} width={20} /> {t("tokenOpenAI")}</>,
      subOptions: tokens?.tokens?.filter(tok => tok.type === "gpt").map(tok => {   return { display: tok.token.slice(0, 23), value: tok.token } })

    },
    {
      name: t('claudeAnthropic'),
      label:<> <ClaudeAnthropic height={20} width={20} /> {t("claudeAnthropic")}</>,
      subOptions: tokens?.tokens?.filter(tok => tok.type === "claudeAnthropic").map(tok => {   return { display: tok.token.slice(0, 23), value: tok.token } })


    },
    {
      name: t('tokenDeekSeek'),
      label: t("tokenDeekSeek"),
      subOptions: []

    },
  ];

  let optionsFiltered = options.filter(option => option?.subOptions?.length > 0)


  // let selectedOption = user?.tokens?.find(tok => tok.active)
  const currentToken = tokens?.tokens?.find(tok => tok.active)?.token

  const [selectedOption, setSelectedOption] = useState({ [t('tokenOpenAI')]: currentToken });


  const [isListening, setIsListening] = useState(false);
  const [transcript, setTranscript] = useState("");
  const recognitionRef = useRef(null);



  // Función auxiliar para manejar texto de manera segura
  const safeText = (text) => {
    if (typeof text === 'string') {
      return text;
    }
    if (text === null || text === undefined) {
      return '';
    }
    if (typeof text === 'object') {
      return JSON.stringify(text);
    }
    return String(text);
  };

  // Función para formatear texto similar a WhatsApp
  const formatWhatsAppText = (text) => {
    if (!text || typeof text !== 'string') return '';

    // Patrones de formateo similares a WhatsApp
    const patterns = [
      // **texto** -> negrita
      { regex: /\*\*(.*?)\*\*/g, replacement: '<b>$1</b>' },
      // *texto* -> cursiva
      { regex: /\*(.*?)\*/g, replacement: '<i>$1</i>' },
      // __texto__ -> subrayado
      { regex: /__(.*?)__/g, replacement: '<u>$1</u>' },
      // ~~texto~~ -> tachado
      { regex: /~~(.*?)~~/g, replacement: '<s>$1</s>' },
      // `texto` -> código inline
      { regex: /`(.*?)`/g, replacement: '<code>$1</code>' },
      // ```texto``` -> bloque de código
      { regex: /```(.*?)```/gs, replacement: '<pre><code>$1</code></pre>' },
      // # texto -> h1
      { regex: /^# (.*?)$/gm, replacement: '<h1>$1</h1>' },
      // ## texto -> h2
      { regex: /^## (.*?)$/gm, replacement: '<h2>$1</h2>' },
      // ### texto -> h3
      { regex: /^### (.*?)$/gm, replacement: '<h3>$1</h3>' },
      // Saltos de línea
      { regex: /\n/g, replacement: '<br />' }
    ];

    let formattedText = text;

    // Aplicar cada patrón de formateo
    patterns.forEach(pattern => {
      if (typeof formattedText === 'string' && formattedText) {
        formattedText = formattedText.replace(pattern.regex, pattern.replacement);
      }
    });

    return formattedText || '';
  };

  const parseText = (text) => {
    const regex = /(@\w+)/g;
    const parts = text.split(regex);

    return parts.map((part, index) => {
      if (part.startsWith('@')) {
        return (
          <span
            onMouseEnter={() => { if (part != "@not" && !containsArroba) setShowMiniProfileModal(((index + 1) / 2) - 1) }}
            onMouseLeave={() => setShowMiniProfileModal(false)}
            key={index}
            className={styles.mentionWrapper}
          >
            <span
              key={index}
              className={styles.arrobaText}
              onClick={() => {
                if (part != "@not" && !containsArroba) {
                  if ("name" in itemsSelected[((index + 1) / 2) - 1]) {
                    dispatch(setAsset(itemsSelected[((index + 1) / 2) - 1]));
                    dispatch(setFatherNewAsset(chatId ? 'chatId' : agentId ? 'agentId' : 'chat'))
                    dispatch(setIdFatherNewAsset(chatId ? { agentId, chatId } : agentId))
                    navigate(`/admin/assets/${itemsSelected[((index + 1) / 2) - 1]._id}`, { state: { backgroundLocation: location } });
                  } else if ("contactName" in itemsSelected[((index + 1) / 2) - 1]) {
                    dispatch(setContact(itemsSelected[((index + 1) / 2) - 1]));
                    dispatch(setFatherNewContact(chatId ? 'chatId' : agentId ? 'agentId' : 'chat'));
                    dispatch(setFatherIdNewContact(chatId ? { agentId, chatId } : agentId))
                    navigate(`/admin/contacts/${itemsSelected[((index + 1) / 2) - 1]._id}`, { state: { backgroundLocation: location } });
                  }
                }
              }}
            >
              {part}
            </span>
            {showMiniProfileModal === ((index + 1) / 2) - 1 && (

              <MiniProfileModal
                item={itemsSelected[((index + 1) / 2) - 1]}
                showMiniProfileModal={showMiniProfileModal}
                index={((index + 1) / 2) - 1}
                name={itemsSelected[((index + 1) / 2) - 1]?.name ? itemsSelected[((index + 1) / 2) - 1].name : itemsSelected[((index + 1) / 2) - 1].contactName ? itemsSelected[((index + 1) / 2) - 1].contactName : ""}
                email={itemsSelected[((index + 1) / 2) - 1]?.companyEmail ? itemsSelected[((index + 1) / 2) - 1].companyEmail : itemsSelected[((index + 1) / 2) - 1].description ? itemsSelected[((index + 1) / 2) - 1].description : ""}
                imageUrl={itemsSelected[((index + 1) / 2) - 1]?.image ? itemsSelected[((index + 1) / 2) - 1].image : emptyImage}
              />
            )
            }
          </span>
        );
      }
      // Preservar saltos de línea convirtiendo \n en elementos <br />
      return part.split('\n').map((line, lineIndex) => (
        <React.Fragment key={`${index}-${lineIndex}`}>
          {lineIndex > 0 && <br />}
          {line}
        </React.Fragment>
      ));
    });
  };


  const handleClickFocus = () => {
    textareaRef.current?.focus();
  };



  const handleToggleSound = () => {
    setMuted(prevMuted => {
      const newMuted = !prevMuted;

      console.log('newMuted', newMuted)
      if (!newMuted) {
        window.speechSynthesis.cancel();
      }

      localStorage.setItem("mutedSound", newMuted.toString());
      return newMuted;
    });
  };


  const renderMessage = () => {
    if (isTokenValid == "loading") {
      return <p className={styles.loading}>{t("verifyingToken")}</p>;
    }

    if (isTokenValid == "not-auth") {
      return (
        <p className={styles.errorAlert}>
          {t("enterA")}{" "}
          <a
            href="https://platform.openai.com/settings/organization/api-keys"
            target="_blank"
          >
            {t("token")}
          </a>{" "}
          {t("validForUsingFactura")}
        </p>
      );
    }

    if (isTokenValid == "auth") {
      return (
        <p className={styles.errorAlert}>{t("facturaGPTCanMakeMistakes")}</p>
      );
    }
  };

  const renderApi = (type) => {
    switch (type) {
      case "google":
        return <ModalConnectionGoogle />;
    }

    return <div>{t("continueTheGameHere")}</div>;
  };



  const restartLastMessageFn = async () => {
    setAutoClear((prev) => !prev)
    const res = await dispatch(restartLastMessage({ chatId }));

  };

  const searchInWebFn = async () => {
    setSearchInWeb((prev) => !prev)

    const res = await dispatch(searchInWebAction({ chatId }));
  }


  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (dragTimeoutRef.current) {
      clearTimeout(dragTimeoutRef.current);
    }
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    if (dragContainerRef.current && !dragContainerRef.current.contains(e.relatedTarget)) {
      setIsDragging(false);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isDragging) {
      setIsDragging(true);
    }
  };

  const handleDrop = async (e, auto) => {
    e.preventDefault();
    e.stopPropagation();
    if (dragTimeoutRef.current) {
      clearTimeout(dragTimeoutRef.current);
    }
    dragCounterRef.current = 0;


    const isAutomateArea = e.target.closest(`.${styles.messageDragAgent}`);
    const isAttachmentArea = attachmentAreaRef.current?.contains(e.target);

    try {
      const files = e.dataTransfer.files;
      if (files && files.length > 0) {
        if (isAutomateArea) {
          const file = files[0];
          const fileType = file.type;
          const fileExtension = file.name.split(".").pop().toLowerCase();
          const fileInfo = {
            name: file.name,
            size: (file.size / 1024).toFixed(2) + " KB",
            type: fileType,
            extension: fileExtension,
          };


          if (fileExtension === "xlsx") {
            fileInfo.content = await handleExcelFile(file);
          } else if (fileType.startsWith("text/") || fileExtension === "json") {
            fileInfo.content = await readFileAsText(file);
          } else if (fileExtension === "pdf") {
            try {
              const base64 = await readFileAsDataURL(file);

              const base64Content = base64.split(',')[1];
              fileInfo.content = base64Content;
            } catch (error) {
              console.error('Error procesando PDF:', error);
              fileInfo.error = 'Error procesando el archivo PDF';
            }
          } else if (fileType.startsWith("image/")) {
            const base64 = await readFileAsDataURL(file);
            const base64Content = base64.split(',')[1];
            fileInfo.content = base64Content;
          }

          setFilePayload(fileInfo);
          setIsDropping({ success: true, ...auto });


        } else if (isAttachmentArea) {

          const event = {
            target: { files },
            preventDefault: () => { },
            stopPropagation: () => { }
          };
          await handleFileChange(event);
          setIsDropping(false);
          setIsDragging(false);
        }
      }
    } catch (error) {
      console.error('Error handling file drop:', error);
    }
  };


  const fnSendMessage = async (auto) => {
    setProcessingTime(0)

    const fileExtension = filePayload?.extension || '';
    const fileName = filePayload?.name || '';
    const fileSize = filePayload?.size || '';

    let updatedEvents = [...events]

    updatedEvents[0].data = {
      size: fileSize,
      name: fileName,
      extension: fileExtension,
      time: 0
    }

    updatedEvents[1].data = {
      id: auto.id,
      name: auto.inputValue,
      type: auto.type,

      timestamp: new Date().toISOString(),
      time: 0
    }


    const index = automations.findIndex(item => item._id === auto._id)
    if (index !== -1) {
      setSelectedAutomate(auto._id)
      setAutomations(prev => {
        const newAutomations = [...prev];
        newAutomations[index].automate = updatedEvents;
        return newAutomations;
      })
    }


    const user = localStorage.getItem("user");
    const userJson = JSON.parse(user);
    const token = userJson.accessToken;

    const frontendTime = new Date().getTime();


    setLoadingStates(prev => {
      const newStates = [...prev];
      newStates[0] = 'pending';
      return newStates;
    });

    const res = await fetch(`${apiUrl}/api/chat/${selectedAgent._id}/${chatId}/messages`, {
      method: "POST",
      body: JSON.stringify({
        text: 'event',
        isAutomate: true,
        automate: updatedEvents,
        file: filePayload
      }),
      headers: {
        "Content-Type": "application/octet-stream",
        Authorization: `Bearer ${token}`,
      },

    }).then((response) => {
      if (response.ok) {
        // const reader = response.body.getReader();
        const reader = response.body.getReader();

        const decoder = new TextDecoder();
        let accumulatedChunks = "";
        let accumulatedText = "";
        let loadStates = [false, false, false, false]

        const processStream = async () => {
          while (true) {
            const { done, value } = await reader.read();
            if (done) {

              if (accumulatedText && typeof accumulatedText === 'string' && !isGraph && !isApi && !isAction && !isTable && !isAutomate && !isAsset && !isImage && !isAudio && !isOnline) {
                const utterance = new SpeechSynthesisUtterance(accumulatedText);
                utterance.lang = 'es-ES';
                window.speechSynthesis.speak(utterance);
              }
              break;
            }

            const chunk = decoder.decode(value, { stream: true });
            accumulatedChunks += chunk;

            let lines = accumulatedChunks.split("\n");
            accumulatedChunks = lines.pop();


            for (const line of lines) {
              if (line.trim()) {
                try {
                  const chunk = JSON.parse(line);
                  const { text, type, threadId, docId, appId } = chunk.data;
                  setTokenInput(chunk?.data?.input.token)

                  setTokenOutput(chunk?.data?.output.token)
                  setShowInfoMessage(true)

                  const backendTime = chunk?.finishedAt;
                  const diff = frontendTime - backendTime;
                  setTimeToFinishResponse(backendTime)

                  if (type === "automate") {
                    if (text?.type === 'data-error') {
                      setIsDropping(false)
                      setIsDragging(false)
                      reader.cancel();
                      setLoadingStates(prev => Array(6).fill(undefined));

                      break
                    }

                    if (text?.type === 'loaded' && loadStates[0] === false) {
                      loadStates[0] = true

                      setLoadingStates(prev => {
                        const newStates = [...prev];
                        newStates[0] = 'active';
                        newStates[1] = 'pending';
                        return newStates;
                      });

                      setTimeout(() => {
                        setLoadingStates(prev => {
                          const newStates = [...prev];
                          newStates[1] = 'active';
                          newStates[2] = 'pending';
                          return newStates;
                        });
                      }, 2000);
                    } else if (text.type === 'data-processed' && loadStates[1] === false) {
                      loadStates[1] = true

                      updatedEvents = text?.data

                      const index = automations.findIndex(item => item._id === auto._id)
                      setAutomations(prev => {
                        const newAutomations = [...prev];
                        newAutomations[index].automate = updatedEvents;
                        return newAutomations;
                      })


                      setLoadingStates(prev => {
                        const newStates = [...prev];
                        newStates[2] = 'active';
                        newStates[3] = 'pending';
                        return newStates;
                      });



                    } else if (text.type === 'data-finished' && loadStates[2] === false) {
                      loadStates[2] = true
                      setLoadingStates(prev => {
                        const newStates = [...prev];
                        newStates[3] = 'active';
                        newStates[4] = 'pending';
                        return newStates;
                      });


                      setTimeout(() => {
                        setLoadingStates(prev => {
                          const newStates = [...prev];
                          newStates[4] = 'active';
                          return newStates;
                        });
                      }, 2000);



                      const time = Math.abs(frontendTime - new Date().getTime()) / 1000
                      setProcessingTime(time)

                      setEndTime(time)
                      setShowImportAttachment(true)


                      const index = automations.findIndex(item => item._id === auto._id)

                      if (index !== -1) {
                        let message = {
                          type: 'bot',
                          isAutomate: true,
                          text: automations[index]?.automate,
                          timestamp: new Date().toISOString()
                        }

                        if (autoClear) {
                          setMessages([message])
                        } else {
                          setMessages(prev => {
                            return [...prev, message];;
                          })
                        }
                      }


                    }
                  }

                } catch (error) {
                  console.error("Failed to parse JSON:", error);
                }
              }
            }
          }
        };

        processStream()
          .then(() => { })
          .catch(console.error);
      }
    });

  }


  const handleKeyDown = (e) => {
    if (e.key === 'y') {
      setIsDropping(false);
      setShowImportAttachment(false);
    }
  }

  const handleImportData = async () => {
    try {

      const automate = automations.find(item => item._id === selectedAutomate)

      const response = await dispatch(importData({
        data: automate.automate[3].data?.processedData,
      }))


      setIsDragging(false);
      setIsDropping(false);
      setShowImportAttachment(false);
    } catch (error) {
      // console.log('error', error)
    }
  }





  const sendTranscriptIfReady = () => {
    const transcript = finalTranscriptRef.current.trim();
    if (!transcript) {
      return
    }

    if (selectedAgent?._id) {
      setInputValue("");

      setIsPaused(false);
      setTokenInput(transcript?.length)
      handleChat({
        text: transcript,
        agent: selectedAgent?.name,
        agentId: selectedAgent?._id,
        file: filePayload,
      });
      setFilePayload(null);
      setFileInfo(null);

    }
  };

  const startCountdown = () => {
    if (countdownRef.current) return;
    setCountdownNumber(5);

    countdownRef.current = setInterval(() => {
      setCountdownNumber((prev) => {
        if (prev === 1) {
          clearInterval(countdownRef.current);
          countdownRef.current = null;
          setCountdownNumber(null);
          stopRecordingAndSend();
          return null;
        }


        return prev - 1;
      });
    }, 1000);

  };



  const stopRecordingAndSend = () => {
    if (voiceChat) {
      recognitionRefAudio.current?.stop();
      setVoiceChat(false);
    }
  };



  const cancelCountdown = () => {
    if (countdownRef.current) {
      clearInterval(countdownRef.current);
      countdownRef.current = null;
    }
    setCountdownNumber(null);
  };
  const handleClick = (e) => {
    e.preventDefault();

    cancelCountdown();

    if (!voiceChat) {
      setFinalTranscript("");
      setVoiceChat(true);
      recognitionRefAudio.current?.start();
    } else {
      stopRecordingAndSend();
    }
  };



  // Función para navegar hacia abajo en la memoria (mensajes más nuevos)
  const navigateHistoryDown = () => {
    if (messageHistory.length === 0) return;

    // Si el input está vacío o estamos navegando, permitir navegación
    if (inputValue === '' || isNavigatingHistory) {
      const newIndex = Math.min(messageHistory.length, historyIndex + 1);
      setHistoryIndex(newIndex);
      setIsNavigatingHistory(true);

      if (newIndex === messageHistory.length) {
        setInputValue(''); // Mensaje vacío al final
      } else {
        setInputValue(messageHistory[newIndex]);
      }
    }
  };



  // Función para navegar hacia arriba en la memoria (mensajes más antiguos)
  const navigateHistoryUp = () => {
    if (messageHistory.length === 0) return;

    // Si el input está vacío o estamos navegando, permitir navegación
    if (inputValue === '' || isNavigatingHistory) {
      const newIndex = Math.max(0, historyIndex - 1);
      setHistoryIndex(newIndex);
      setIsNavigatingHistory(true);

      if (newIndex < messageHistory.length) {
        setInputValue(messageHistory[newIndex]);
      }
    }
  };




  // Función para guardar un mensaje en la memoria
  const saveMessageToHistory = (message) => {
    if (!message || message.trim() === '') return;

    try {
      const currentHistory = [...messageHistory];

      // Evitar duplicados consecutivos
      if (currentHistory[currentHistory.length - 1] !== message.trim()) {
        currentHistory.push(message.trim());

        // Mantener máximo 50 mensajes
        if (currentHistory.length > 50) {
          currentHistory.shift(); // Eliminar el más antiguo
        }

        setMessageHistory(currentHistory);
        localStorage.setItem('chatMessageHistory', JSON.stringify(currentHistory));
      }

      // Resetear el índice al final
      setHistoryIndex(currentHistory.length);
    } catch (error) {
      console.error('Error saving message to history:', error);
    }
  };

  const adjustTextareaHeight = useCallback(() => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    // Reset height to auto to get the correct scrollHeight
    textarea.style.height = 'auto';

    // Set the height to match the content
    const newHeight = Math.min(textarea.scrollHeight, 200); // Max height of 200px
    textarea.style.height = `${newHeight}px`;

    // Hacer scrollbottom en el contenedor de mensajes
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;

    }

  }, []);



  const loadMessageHistory = () => {
    try {
      const stored = localStorage.getItem('chatMessageHistory');
      if (stored) {
        const history = JSON.parse(stored);
        setMessageHistory(history);
        setHistoryIndex(history.length); // Índice al final (mensaje vacío)
      }
    } catch (error) {
      console.error('Error loading message history:', error);
    }
  };




  const renderTextAutomate = (event, type = 'description') => {
    const { description, title, data } = event;

    let text = type === 'description' ? description : title;

    if (!text) return '';


    if (type == 'time') {
      return (data.time / 1000).toFixed(1) + 's'
    }

    const matches = text.match(/\{([^}]+)\}/g) || [];
    const parameters = matches.map(match => match.slice(1, -1));

    if (parameters.length === 0) {
      return text;
    }

    let result = text;
    let isShow = false

    for (const param of parameters) {
      if (param === 'timestamp' && data[param]) {
        isShow = true
        result = result.replace(new RegExp(`\\{${param}\\}`, 'g'), formatAgoDate({ dateString: data[param], t }))
      } else if (typeof data !== 'object' && data !== null) {
        isShow = true
        result = result.replace(new RegExp(`\\{${param}\\}`, 'g'), data);
      } else if (data && typeof data === 'object' && data[param] !== undefined && data[param] !== null) {
        isShow = true
        result = result.replace(new RegExp(`\\{${param}\\}`, 'g'), data[param]);
      }
    }


    if (!isShow) {
      if (type == 'title') {
        return event.default || 'not found'
      }

      return ""
    }

    return result;
  }



  const toggleVariableEditing = (index, originalValue) => {
    setEditingVariableIndices(prev => {
      const isCurrentlyEditing = prev.includes(index);
      if (isCurrentlyEditing) {
        // Si está editando, desactivar edición
        return prev.filter(i => i !== index);
      } else {
        // Si no está editando, activar edición
        setEditingVariableValues(prev => ({
          ...prev,
          [index]: originalValue
        }));
        return [...prev, index];
      }
    });
  };

  const handleVariableChange = (index, value) => {
    setEditingVariableValues(prev => ({
      ...prev,
      [index]: value
    }));
  };

  const handleVariableSave = (index) => {
    // Aquí podrías guardar el valor editado en el estado del mensaje
    // Por ahora solo salimos del modo edición
    setEditingVariableIndices(prev => prev.filter(i => i !== index));
  };

  const handleVariableCancel = (index) => {
    setEditingVariableIndices(prev => prev.filter(i => i !== index));
    setEditingVariableValues(prev => {
      const newValues = { ...prev };
      delete newValues[index];
      return newValues;
    });
  };

  const handleVariableKeyDown = (e, index) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleVariableSave(index);
    } else if (e.key === 'Escape') {
      e.preventDefault();
      handleVariableCancel(index);
    }
  };


  const readerMessageRef = useRef(null);



  const handleFileUpdate = async (operation, path, content = null, appId) => {
    console.log('🔄 handleFileUpdate called:', { operation, path, contentLength: content?.length, appId });

    try {
      const user = localStorage.getItem("user");
      const userJson = JSON.parse(user);
      const token = userJson.accessToken;

      const payload = {
        type: operation,
        appId: appId,
        text: {
          path,
          content,
          ...(operation === 'renameFile' && content && {
            oldPath: path,
            newPath: content.newPath
          })
        }
      };

      console.log('📤 Sending payload to backend:', payload);
      const startTime = Date.now();

      await fetch(`${apiUrl}/api/chat/${selectedAgent._id}/${chatId}/messages`, {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/octet-stream",
          Authorization: `Bearer ${token}`,
        },
      }).then((response) => {

        console.log("response apapapap", response)
        if (response.ok) {
          // const reader = response.body.getReader();
          readerMessageRef.current = response.body.getReader();

          const decoder = new TextDecoder();
          let accumulatedChunks = "";
          // let accumulatedText = "";


          const processStream = async () => {
            while (true) {
              // Verificar si está pausado antes de leer
              // if (isPausedRef.current) {
              //   await new Promise(resolve => setTimeout(resolve, 100));
              //   continue;
              // }

              const { done, value } = await readerMessageRef.current.read();
              if (done) {
                setFinishedResponseBot(true)
                setIsLoadBot(false);
                break;
              }

              const chunk = decoder.decode(value, { stream: true });

              // console.log("app chunk", chunk)
              accumulatedChunks += chunk;

              let lines = accumulatedChunks.split("\n");
              accumulatedChunks = lines.pop();

              for (const line of lines) {
                if (line.trim()) {
                  try {
                    const chunk = JSON.parse(line);
                    const { text, type, appId, timestamp } = chunk.data;
                    setTokenOutput((prev) => Number(prev || 0) + Number(chunk?.data?.output.token));

                    console.log("app chunkdata", chunk.data)
                    console.log("app chunk", text)
                    console.log("app appId", appId)
                    console.log("app type", type)
                    console.log("app timestamp", timestamp)

                    setShowInfoMessage(true)

                    const firstBackendResponseTime = Date.now();
                    const timeDiffMs = firstBackendResponseTime - startTime;

                    setTimeToFinishResponse(timeDiffMs);

                    if (type == "pause") {
                      setMessages((prevMessages) => {
                        const newMessages = [...prevMessages];
                        newMessages.push({ text: "parar el mensaje", type: "pause" });
                        return newMessages;
                      });
                    } else if (type == "app") {
                      console.log('📁 Received app type response:', text);

                      // Si hay información de archivo, mostrarla
                      if (text && typeof text === 'object' && text.buffer) {
                        const fileInfo = text.fileInfo;
                        console.log('📄 File operation info:', fileInfo);

                        // Mostrar información del archivo que se está procesando
                        const fileMessage = `🔄 ${fileInfo.operation} en archivo: ${fileInfo.path}`;

                        // Actualizar el mensaje local con la información del archivo
                        setMessages(prevMessages => {
                          return prevMessages.map(message => {
                            if (message.appId === appId) {
                              return {
                                ...message,
                                text: {
                                  ...message.text,
                                  fileOperation: fileMessage,
                                  fileInfo: fileInfo,
                                  buffer: text.buffer // Incluir el buffer con el contenido del archivo
                                }
                              };
                            }
                            return message;
                          });
                        });
                      } else {
                        // Actualizar el mensaje local con los nuevos archivos
                        setMessages(prevMessages => {
                          return prevMessages.map(message => {
                            if (message.appId === appId) {
                              return {
                                ...message,
                                text: text || message.text
                              };
                            }
                            return message;
                          });
                        });
                      }

                    } else {
                      insertMessage({ text, threadId, docId, appId, timestamp });
                    }
                  } catch (error) {
                    console.error("Failed to parse JSON:", error);
                  }
                }
              }
            }
          };

          processStream()
            .then(() => { })
            .catch(console.error);
        }

      })


    } catch (error) {
      console.error('❌ Error updating file:', error);
      // No lanzar el error para evitar que se borre el archivo local
      console.warn('⚠️ Backend sync failed, but file changes are preserved locally');
    }
  };

  const handleSendVoice = ({ audioBlob, samples }) => {
    setVoiceMessage({ audioBlob, samples });
    setShowVoiceRecorder(false);

    const reader = new FileReader();
    reader.onload = () => {
      const base64String = reader.result.split(',')[1];

      if (!base64String) {
        console.error('Failed to convert audio to base64');
        return;
      }

      handleSendMessage({
        text: "",
        record: {
          audioBlob: base64String,
          samples
        },
        agentName: selectedAgent?.name,
        agentId: selectedAgent?._id,
      })
    };

    reader.onerror = (error) => {
      console.error('Error converting audio to base64:', error);
    };
    reader.readAsDataURL(audioBlob);
  };





  const checkReplyMessage = (message) => {
    const replyMessage = messages.find(msg => msg.timestamp === message.replyId.timestamp)

    if (replyMessage) {
      const element = document.querySelector(`[data-timestamp="${replyMessage.timestamp}"]`);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    } else {
    }
  }

  const tokenSelected = async (tokenText) => {

    if (tokens?.tokens?.find(tok => tok.token == tokenText)) {

      await dispatch(updateAccount({
        data: {
          ...user,
          tokenGPT: tokenText
        }
      }));


      await dispatch(updateTokens({
        data: {
          ...tokens,
          tokens: [...tokens?.tokens?.map(tok => {
            if (tok.token === tokenText) return { token: tok.token, active: true , type:tok.type }
            else return { token: tok.token, active: false , type:tok.type }
          }).sort((a, b) => {
            if (a.active === b.active) return 0;
            return a.active ? -1 : 1;
          })],
          tokenGPT: tokenText
        },
        id: user?.id?.split("_").pop()
      }));
    }
  }

  useEffect(() => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    const handleScroll = () => {
      setScrollTop(textarea.scrollTop);
    };

    textarea.addEventListener('scroll', handleScroll);
    return () => textarea.removeEventListener('scroll', handleScroll);
  }, []);



  useEffect(() => {
    const fn = async () => {
      const response = await dispatch(getAutomatesByIds({ ids: selectedAgent?.automations }))

      if (response.payload.success) {
        setAutomations(response.payload.automations)
      }
    }


    if (selectedAgent?._id && selectedAgent?.automations?.length > 0) {
      fn()
    }
  }, [selectedAgent?._id]);





  const contactsRef = useRef(null);

  const handleBlur = (event) => {
    setTimeout(() => {
      if (
        contactsRef.current &&
        !contactsRef.current.contains(event.relatedTarget)
      ) {
        setIsFocused(false);
      }
    }, 100);
  };

  const actions = [
    {
      id: 0,
      img: orangeAgentIcon,
      text: t("createAnAgent"),
      action: () => {
        // setIdSelectedAgent(null);
        navigate(`/admin/agent`, { state: { backgroundLocation: location } });
      },
    },
    {
      id: 1,
      img: analizeBill,
      text: t("analyzeYourBilling"),
    },
    {
      id: 2,
      img: analizeBill,
      text: t("createAnInvoice"),
    },
    {
      id: 3,
      img: askDocument,
      text: t("askAboutYourDocuments"),
      message: t("documentMessages"),
    },
    {
      id: 4,
      img: askAssets,
      text: t("askAbourYourAssets"),
      message: t("assetMessages"),
    },
    {
      id: 5,
      img: askClient,
      text: t("askAbourYourClients"),
      message: t("contactMessages"),
    },
    {
      id: 6,
      img: askHelp,
      text: t("askForHelp"),
    },
  ];

  const [isModalAutomate, setIsModalAutomate] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const [showCreateFolder, setShowCreateFolder] = useState(false);
  const [showLocationModal, setShowLocationModal] = useState(false);

  const [showNewTagModal, setShowNewTagModal] = useState(false);
  const [showNewContact, setShowNewContact] = useState(false);
  const [showNewProduct, setShowNewProduct] = useState(false);
  const [showNewBill, setShowNewBill] = useState(false);
  const [showUploadFile, setShowUplaodFile] = useState(false);
  const buttonRefs = useRef({});

  const automateData = AutomateDataComponent()





  const openModalAutomate = () => {
    setIsModalAutomate(true);
    setIsOpen(false);
  };
  const closeModalAutomate = () => {
    setTypeContentAutomate("");
    setIsModalAutomate(false);
  };


  const buildChatGptPayload = (info) => {
    return {
      name: info.name,
      type: info.type,
      extension: info.extension,
      content:
        info.content ||
        info.base64 ||
        info.message ||
        "Sin contenido procesado",
    };
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const fileType = file.type;
    const fileExtension = file.name.split(".").pop().toLowerCase();

    let fileInfo = {
      name: file.name,
      size: (file.size / 1024).toFixed(2) + " KB",
      type: fileType,
      extension: fileExtension,
    };

    try {
      if (fileExtension === "xlsx") {
        fileInfo.content = await handleExcelFile(file);
      } else if (fileType.startsWith("text/") || fileExtension === "json") {
        fileInfo.content = await readFileAsText(file);
      } else if (fileType.startsWith("image/") || fileExtension === "pdf") {
        fileInfo.base64 = await readFileAsDataURL(file);
      } else {
        fileInfo.message = "Tipo de archivo no manejado específicamente";
      }

      setFileInfo(fileInfo);
      setFilePayload(buildChatGptPayload(fileInfo));
    } catch (error) {
      console.error("Error procesando archivo:", error);
    }
  };

  const readFileAsText = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsText(file);
    });
  };

  const readFileAsDataURL = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = reader.result;
        resolve(base64);
      };
      reader.onerror = (error) => {
        console.error('Error reading file:', error);
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  };

  const handleExcelFile = async (file) => {
    const arrayBuffer = await file.arrayBuffer();
    const data = new Uint8Array(arrayBuffer);
    const workbook = XLSX.read(data, { type: "array" });
    const sheetName = workbook.SheetNames[0];
    const sheet = workbook.Sheets[sheetName];
    return XLSX.utils.sheet_to_json(sheet);
  };

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };


  const handleButtonMicrophone = async () => {
    try {
      if (
        !("webkitSpeechRecognition" in window) &&
        !("SpeechRecognition" in window)
      ) {
        alert("Tu navegador no soporta reconocimiento de voz.");
        return;
      }

      if (!recognitionRef.current) {
        const SpeechRecognition =
          window.SpeechRecognition || window.webkitSpeechRecognition;
        const recognition = new SpeechRecognition();

        recognition.lang = "es-ES";
        recognition.continuous = true;
        recognition.interimResults = true;

        recognition.onstart = () => {
          setIsListening(true);
        };

        recognition.onresult = (event) => {
          const current = event.resultIndex;
          const transcription = event.results[current][0].transcript;
          setTranscript(transcription);

          if (event.results[current].isFinal) {
            setIsListening(false);
            handleChat({
              text: transcription,
              agent: selectedAgent?.name,
              agentId: selectedAgent?._id,
            });
          }
        };

        recognition.onerror = (event) => {
          console.error("Error en reconocimiento:", event.error);
          setIsListening(false);
        };

        recognition.onend = () => {
          setIsListening(false);
        };

        recognitionRef.current = recognition;
      }

      const recognition = recognitionRef.current;

      if (!isListening) {
        recognition.start();
      } else {
        recognition.stop();
      }
    } catch (error) {
      console.error("Error al iniciar el reconocimiento de voz:", error);
      alert("Error al iniciar el reconocimiento de voz");
    }
  };



  useEffect(() => {
    const fn = async () => {
      const response = await dispatch(validateTokenGPT());
      if (response.payload.success) {
        setIsTokenValid("auth");
      } else {
        setIsTokenValid("not-auth");
      }
    };

    fn();
  }, []);


  useEffect(() => {
    if (!inputValue && proptText) {
      setInputValue(proptText);
    }
  }, [proptText]);


  useEffect(() => {
    if (messages.length > 0) {
      const lastMessage = messages[messages.length - 1]
      if (lastMessage.type === 'bot' && lastMessage.text !== lastMessageText) {
        setLastMessageText(lastMessage.text)
        setLastMessageTime(Date.now())
      }

      // Scroll automático hacia abajo cuando hay nuevos mensajes
      if (messageContainerRef.current) {
        setTimeout(() => {
          messageContainerRef.current.scrollTop = messageContainerRef.current?.scrollHeight;
        }, 100);
      }
    }
  }, [messages])



  useEffect(() => {
    // Cancelar cualquier síntesis de voz en curso si está silenciado
    if (muted) {
      window.speechSynthesis.cancel();
      return;
    }

    // Solo reproducir si hay un mensaje nuevo y no está silenciado
    if (lastMessageText && !muted && iniVoice) {
      const timeoutId = setTimeout(() => {
        const currentTime = Date.now()
        if (currentTime - lastMessageTime >= 3000) {
          console.log('lastMessageText', lastMessageText)
          const currentMessage = lastMessageText?.replaceAll('\n', ' ')
          const utterance = new SpeechSynthesisUtterance(currentMessage)
          utterance.lang = 'es-ES'
          window.speechSynthesis.speak(utterance)
        }
      }, 3000)

      return () => {
        clearTimeout(timeoutId)
      }
    }

    // Inicializar el estado de voz solo una vez
    if (!iniVoice) {
      setIniVoice(true)
    }
  }, [lastMessageText, lastMessageTime, muted, iniVoice])



  useEffect(() => {
    if (newChat) {
      setNewChat(false)

    } else {

    }
  }, [messages]);



  useEffect(() => {
    return () => {
      if (dragTimeoutRef.current) {
        clearTimeout(dragTimeoutRef.current);
      }
    };
  }, []);




  useEffect(() => {
    if (!isDropping.success) return;

    setLoadingStates([false, false, false, false, false, false]);

    fnSendMessage(isDropping);

  }, [isDropping, filePayload]);





  useEffect(() => {
    const selectedChatId = localStorage.getItem('selectedChatId');
    const noMessages = messages?.length === 0;
    const shouldShow = !isAgentPopup && !selectedChatId;

    if (shouldShow) {
      if (windowWidth >= 768) {
        setShouldRenderActions(!inputValue && noMessages);
      } else {
        setShouldRenderActions(true);
      }
    } else {
      setShouldRenderActions(false);
    }


    if (inputValue === '') {
      setIsNavigatingHistory(false)
    }
  }, [isAgentPopup, windowWidth, inputValue, messages]);



  // Cargar la memoria de mensajes al inicializar
  useEffect(() => {
    loadMessageHistory();
  }, []);

  // Inicializar el índice de navegación cuando se carga la memoria
  useEffect(() => {
    if (messageHistory.length > 0) {
      setHistoryIndex(messageHistory.length);
    }
  }, [messageHistory]);

  useEffect(() => {
    if (!("webkitSpeechRecognition" in window) && !("SpeechRecognition" in window)) {
      alert("Tu navegador no soporta reconocimiento de voz");
      return;
    }

    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    const recognition = new SpeechRecognition();
    recognition.lang = "es-ES";
    recognition.interimResults = true;
    recognition.continuous = true;

    recognition.onresult = (event) => {
      let interimTranscript = "";
      let final = "";
      for (let i = event.resultIndex; i < event.results.length; ++i) {
        if (event.results[i].isFinal) {
          final += event.results[i][0].transcript;
        } else {
          interimTranscript += event.results[i][0].transcript;
        }
      }
      if (final) {
        setFinalTranscript((prev) => {
          const updated = prev + final;
          finalTranscriptRef.current = updated;
          return updated;
        });

      }

    };

    recognition.onerror = (event) => {
      console.error("Speech recognition error", event.error);
    };

    recognition.onend = () => {
      sendTranscriptIfReady();
    };

    recognitionRefAudio.current = recognition;

    if (selectedAgent?._id) {
      sendTranscriptIfReady()
    }

    // ----------------------------

    return () => {
      recognition.stop();

    };

  }, [selectedAgent]);




  useEffect(() => {
    const interval = setInterval(() => {
      if (!recorderRef.current) return;
      setHasStoppedRecording(!recorderRef.current.isRecording());
      setIsPlaying(recorderRef.current.isPlaying());
      setIsRecording(recorderRef.current.isRecording());
    }, 200);

    return () => clearInterval(interval);
  }, []);


  // const messageContainerRef = useRef(null);



  useEffect(() => {
    const container = messageContainerRef.current;
    if (!container) return;

    const handleScroll = () => {
      const entries = Object.entries(dateLabelRefs.current);
      if (!entries.length) return;

      const containerRect = container.getBoundingClientRect();
      const containerTop = containerRect.top;
      let closestIndex = -1;
      let smallestDistance = Infinity;

      // Umbral para la distancia mínima al tope del contenedor
      const threshold = 25; // Pixeles adicionales antes de hacer el cambio

      for (let i = 0; i < entries.length; i++) {
        const [label, el] = entries[i];
        if (!el) continue;

        const rect = el.getBoundingClientRect();

        // Distancia entre el top del elemento y el top del contenedor
        const distanceFromTop = rect.top - containerTop;

        // Consideramos solo los elementos que están dentro del umbral
        if (distanceFromTop <= -threshold) {
          const absDistance = Math.abs(distanceFromTop);

          if (absDistance < smallestDistance) {
            smallestDistance = absDistance;
            closestIndex = i;
          }
        }
      }

      if (closestIndex !== -1) {
        const [newLabel] = entries[closestIndex];

        if (newLabel !== activeDateLabel) {
          setActiveDateLabel(newLabel);
        }
      } else if (entries.length > 0) {
        // Fallback: si ninguno ha pasado el top, usa el primero
        const [firstLabel] = entries[0];
        if (firstLabel !== activeDateLabel) {
          setActiveDateLabel(firstLabel);
        }
      }
    };

    container.addEventListener("scroll", handleScroll);
    handleScroll(); // Ejecutar inicialmente

    return () => container.removeEventListener("scroll", handleScroll);
  }, [messages]);




  useEffect(() => {
    const handleKeyDown = async (e) => {
      if (e.key === 'n') {
        setIsDragging(false);
        setIsDropping(false);
        setShowImportAttachment(false);
      } else if (e.key === 'y') {

        handleImportData()
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isDropping]);




  useEffect(() => {
    adjustTextareaHeight();
  }, [inputValue, adjustTextareaHeight]);


  useEffect(() => {
    if (messages?.length > 0) {
      // console.log('esto es messages',messages)
      const reversedIndex = messages.slice().reverse().findIndex(message => message.type == "me" && message.text.includes("sk-"));
      const realIndex = reversedIndex === -1 ? -1 : messages?.length - 1 - reversedIndex;
      // console.log('findToken',realIndex)
      if (messages?.length > realIndex + 1) {
        const tokenAccepted = messages[realIndex+1].type == "bot" && messages[realIndex+1].text.includes('El token ha sido ingresado correctamente. ¡Acceso autorizado!')
        // const tokenAccepted = false
        // console.log('tokenAccepted',tokenAccepted)
        if (tokenAccepted) {
          const token = messages[realIndex].text
          const fined = tokens?.tokens?.find(tok => tok.token == token)
          const fn = async () => {
            dispatch(getTokens({ id: user?.id?.split("_").pop() }))
          }
          if (!fined) fn()

        }

      }
    }
  }, [messages])

  // const options = user?.tokens?.map(tok => {return {icon: TokenOpenAI, text:tok.token}})



  useEffect(() => {
    tokenSelected(selectedOption[t("tokenOpenAI")]);
  }, [selectedOption[t("tokenOpenAI")]]);



  const [expandedMessages, setExpandedMessages] = useState(new Set())

  // Function to navigate between sections in MessageDoc
  const navigateToSection = (direction = 'next') => {
    // Find the MessageDoc component in the DOM
    const messageDocContainer = document.querySelector('[class^="messageDocContainer"]');
    if (messageDocContainer) {
      const editor = messageDocContainer.querySelector('[class^="editor_"]');

      console.log('editor', editor)
      if (editor) {
        const sections = Array.from(editor.querySelectorAll('section'));
        const currentIndex = sections.findIndex(section => section.id === selectedSectionId);

        if (currentIndex !== -1) {
          let newIndex;
          if (direction === 'next') {
            newIndex = (currentIndex + 1) % sections.length;
          } else {
            newIndex = currentIndex === 0 ? sections.length - 1 : currentIndex - 1;
          }

          const newSection = sections[newIndex];
          if (newSection && newSection.id) {
            dispatch(setMessageDocsSelectedSection(newSection.id));
            newSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      }
    }
  };

  const [showFolderIndicator, setShowFolderIndicator] = useState(false);
  const [selectedFolderPath, setSelectedFolderPath] = useState('');
  const [hasUserInteracted, setHasUserInteracted] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [hasBeenManuallyTriggered, setHasBeenManuallyTriggered] = useState(false);

  // Debug: Log state changes
  const [showAppIndicator, setShowAppIndicator] = useState(false);
  const [selectedAppData, setSelectedAppData] = useState(null);

  // Obtener el archivo seleccionado del estado de Redux
  const { selectedFile, selectedLines, status: statusApp } = useSelector(state => state.docs.app);

  // Sincronizar selectedFolderPath con el estado de Redux
  useEffect(() => {
    if (selectedFile && selectedFile !== selectedFolderPath) {
      setSelectedFolderPath(selectedFile);
      // NO mostrar automáticamente el indicador de carpeta
      // Solo se mostrará cuando se seleccione una línea en el Monaco Editor
    }
  }, [selectedFile, selectedFolderPath]);

  
  useEffect(() => {
    console.log('🔍 statusApp', statusApp);
  }, [statusApp]);

  // useEffect(() => {
  //   if (status === 'expanded') {
  //     setShowAppIndicator(true);
  //   } else {
  //     setShowAppIndicator(false);
  //   }
  // }, [status]);

  // Función para detectar si un path es una carpeta
  const isFolderPath = (path) => {
    if (!path) return false;
    // Verificar si el path termina con '/' o no tiene extensión de archivo
    return path.endsWith('/') || !path.includes('.') || path.split('/').pop().indexOf('.') === -1;
  };

  // Mostrar folder indicator cuando se selecciona una carpeta o se seleccionan líneas
  // PERO solo si ya se ha mostrado antes (no al inicio)
  useEffect(() => {
    console.log('🔍 FolderIndicator Debug:', {
      isInitialLoad,
      hasBeenManuallyTriggered,
      selectedFile,
      selectedLines,
      showFolderIndicator
    });

    // Solo marcar como activado manualmente si hay una selección real de líneas (no solo cursor)
    if (selectedLines && !isInitialLoad && !hasBeenManuallyTriggered) {
      const { startLine, endLine, startColumn, endColumn } = selectedLines;
      if (startLine !== endLine || startColumn !== endColumn) {
        console.log('🎯 FolderIndicator: Marcando como activado manualmente por selección real de líneas');
        setHasBeenManuallyTriggered(true);
      }
    }

    // No mostrar en la carga inicial o si no ha sido activado manualmente
    if (isInitialLoad) {
      console.log('🚫 FolderIndicator: Bloqueado por carga inicial');
      setShowFolderIndicator(false); // Forzar que esté oculto al inicio
      return;
    }

    // Solo mostrar si ha sido activado manualmente O si hay una selección real de líneas
    const hasRealSelection = selectedLines && (() => {
      const { startLine, endLine, startColumn, endColumn } = selectedLines;
      return startLine !== endLine || startColumn !== endColumn;
    })();

    if (!hasBeenManuallyTriggered && !hasRealSelection) {
      console.log('🚫 FolderIndicator: Bloqueado - no activado manualmente y sin selección real');
      setShowFolderIndicator(false);
      return;
    }

    if (selectedFile) {
      // Verificar si es una carpeta
      const isFolder = isFolderPath(selectedFile);

      if (isFolder) {
        // Si es una carpeta, mostrar el folder indicator
        console.log('📁 FolderIndicator: Mostrando carpeta');
        setShowFolderIndicator(true);
      } else if (selectedLines) {
        // Si es un archivo y hay líneas seleccionadas, verificar que hay una selección real
        const { startLine, endLine, startColumn, endColumn } = selectedLines;
        if (startLine !== endLine || startColumn !== endColumn) {
          console.log('📄 FolderIndicator: Mostrando archivo con líneas seleccionadas');
          setShowFolderIndicator(true);
        } else {
          // Si solo hay cursor (sin selección), mantener el folder indicator visible
          // para archivos seleccionados
          console.log('📄 FolderIndicator: Mostrando archivo con cursor');
          setShowFolderIndicator(true);
        }
      } else {
        // Si es un archivo pero no hay líneas seleccionadas, mostrar el folder indicator
        // para que el usuario pueda interactuar con el archivo
        console.log('📄 FolderIndicator: Mostrando archivo sin líneas');
        setShowFolderIndicator(true);
      }
    } else {
      // Si no hay archivo seleccionado, ocultar el folder indicator
      console.log('🚫 FolderIndicator: Ocultando - no hay archivo seleccionado');
      setShowFolderIndicator(false);
    }
  }, [selectedLines, selectedFile, isInitialLoad, hasBeenManuallyTriggered]);

  // Marcar que ya no es la carga inicial después de un delay más largo
  useEffect(() => {
    console.log('⏰ FolderIndicator: Iniciando timer de 3 segundos');
    const timer = setTimeout(() => {
      console.log('✅ FolderIndicator: Timer completado, permitiendo mostrar');
      setIsInitialLoad(false);
    }, 3000); // Aumentado a 3 segundos
    return () => clearTimeout(timer);
  }, []);

  // Asegurar que el FolderIndicator esté oculto al inicio
  useEffect(() => {
    console.log('🚫 FolderIndicator: Forzando estado inicial a false');
    setShowFolderIndicator(false);
  }, []);

  // Función para manejar clics fuera del área de la aplicación
  const handleClickOutside = useCallback((event) => {
    // Verificar si el clic fue en el área del chat o en el FileExplorer
    const isChatArea = event.target.closest('[class*="chat"]');
    const isFileExplorer = event.target.closest('[class*="FileExplorer"]');
    const isFolderIndicator = event.target.closest('[class*="folderIndicator"]') || 
                              event.target.closest('[class*="FolderIndicator"]') ||
                              event.target.closest('[class*="folderIndicatorContainer"]');

    // Solo cerrar si el clic fue fuera del área del chat, FileExplorer y FolderIndicator
    if (!isChatArea && !isFileExplorer && !isFolderIndicator && showFolderIndicator) {
      setShowFolderIndicator(false);
    }

    if (!isChatArea && !isFileExplorer && showAppIndicator) {
      setShowAppIndicator(false);
    }
  }, [showFolderIndicator, showAppIndicator]);

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [handleClickOutside]);

  const handleFileUpdateCallback = useCallback(async (operation, path, content, appId, timestamp) => {

    // Solo actualizar el estado local con Redux slices
    try {
      if (operation === 'createFile') {
        // Añadir nuevo archivo al estado
        dispatch(setAppFiles(prevFiles => ({ ...prevFiles, [path]: content || '' })));
      } else if (operation === 'editFile') {
        // Actualizar archivo existente
        dispatch(setAppFiles(prevFiles => ({ ...prevFiles, [path]: content || '' })));
      } else if (operation === 'deleteFile') {
        // Eliminar archivo del estado
        dispatch(setAppFiles(prevFiles => {
          const updatedFiles = { ...prevFiles };
          delete updatedFiles[path];
          return updatedFiles;
        }));
      } else if (operation === 'renameFile') {
        // Renombrar archivo
        const oldPath = path;
        const newPath = content?.newPath;
        if (newPath) {
          dispatch(setAppFiles(prevFiles => {
            const updatedFiles = { ...prevFiles };
            if (updatedFiles[oldPath]) {
              updatedFiles[newPath] = updatedFiles[oldPath];
              delete updatedFiles[oldPath];
            }
            return updatedFiles;
          }));
        }
      }

      // Actualizar el mensaje específico con el timestamp
      if (timestamp) {
        setMessages(prevMessages => {
          return prevMessages.map(message => {
            if (message.timestamp === timestamp && message.appId === appId) {
              return {
                ...message,
                // Preservar el contenido existente y actualizar si es necesario
                text: message.text || message.text
              };
            }
            return message;
          });
        });
      }

    } catch (error) {
      console.error('❌ Error updating Redux state:', error);
    }
  }, [dispatch]);

  const handleAddDocument = useCallback(async (originalFilePath, customNewFilePath = null) => {

    try {
      // Buscar el mensaje que contiene la aplicación actual
      const appMessage = messages.find(msg => msg.appId);

      if (!appMessage) {
        console.error('❌ No se encontró mensaje de aplicación');
        return;
      }

      // Obtener el directorio del archivo seleccionado
      const directory = originalFilePath.substring(0, originalFilePath.lastIndexOf('/'));
      const fileName = originalFilePath.split('/').pop();

      // Usar el path personalizado si se proporciona, sino generar uno
      let newFilePath;
      if (customNewFilePath) {
        newFilePath = customNewFilePath;
      } else {
        // Generar un nombre único para el nuevo archivo
        const timestamp = Date.now();
        const newFileName = `${fileName.replace(/\.[^/.]+$/, '')}_copy_${timestamp}${fileName.includes('.') ? fileName.substring(fileName.lastIndexOf('.')) : ''}`;
        newFilePath = `${directory}/${newFileName}`;
      }

      // Crear archivo vacío directamente en Redux
      dispatch(createAppFile({ path: newFilePath, content: '' }));


      // También sincronizar con el backend si es necesario
      if (appMessage.appId) {
        try {
          await handleFileUpdate('createFile', newFilePath, '', appMessage.appId);
        } catch (backendError) {
          console.warn('⚠️ Error syncing with backend, but file created locally:', backendError);
        }
      }

      // Actualizar el mensaje local para que el FileExplorer se actualice
      setMessages(prevMessages => {
        return prevMessages.map(message => {
          if (message.appId) {
            // Asegurarse de que la estructura existe
            const updatedText = message.text || {};
            const updatedFiles = { ...updatedText.files, [newFilePath]: '' };
            return {
              ...message,
              text: {
                ...updatedText,
                files: updatedFiles
              }
            };
          }
          return message;
        });
      });

    } catch (error) {
      console.error('❌ Error creating document:', error);
      throw error; // Re-lanzar el error para que el FolderIndicator lo maneje
    }
  }, [messages, dispatch, handleFileUpdate]);


  // Función auxiliar para obtener la extensión del archivo
  const getFileExtension = (filePath) => {
    const ext = filePath.split('.').pop().toLowerCase();
    switch (ext) {
      case 'jsx':
      case 'tsx':
        return 'jsx';
      case 'js':
        return 'javascript';
      case 'ts':
        return 'typescript';
      case 'css':
      case 'scss':
        return 'css';
      case 'json':
        return 'json';
      case 'md':
        return 'markdown';
      case 'html':
        return 'html';
      default:
        return 'text';
    }
  };

  // Función para abrir el ChatView con el elemento seleccionado
  const handleOpenChatInChatView = useCallback((selectedPath, selectedLines) => {
    // Crear un mensaje inicial basado en el elemento seleccionado
    let initialMessage = '';

    if (isFolderPath(selectedPath)) {
      // Si es una carpeta
      initialMessage = `Necesito ayuda con la carpeta: ${selectedPath}`;
    } else {
      // Si es un archivo
      initialMessage = `Necesito ayuda con el archivo: ${selectedPath}`;

      // Agregar información sobre las líneas seleccionadas si existen
      if (selectedLines) {
        const { startLine, endLine } = selectedLines;
        if (startLine === endLine) {
          initialMessage += `\n\nEspecíficamente con la línea ${startLine}`;
        } else {
          initialMessage += `\n\nEspecíficamente con las líneas ${startLine} a ${endLine}`;
        }
      }

      // Agregar información sobre el tipo de archivo
      const fileType = getFileExtension(selectedPath);
      initialMessage += `\n\nEs un archivo de tipo: ${fileType}`;
    }

    // Establecer el mensaje inicial en el input
    setInputValue(initialMessage);

    // Hacer foco en el textarea
    if (textareaRef.current) {
      textareaRef.current.focus();
    }

    // Cerrar el folder indicator
    setShowFolderIndicator(false);

    console.log('🚀 ChatView abierto con mensaje inicial:', initialMessage);
  }, [isFolderPath, getFileExtension, setInputValue, setShowFolderIndicator]);


  // Estados para el scraping
  const [scrapingStatus, setScrapingStatus] = useState('loading');
  const [scrapingData, setScrapingData] = useState({
    url: '',
    screenshot: null,
    selectors: [],
    template: null,
    results: []
  });

  // Funciones para manejar el scraping
  const handleScrapingStatusChange = (newStatus) => {
    setScrapingStatus(newStatus);
    
    // Si volvemos al estado loading, limpiar datos
    if (newStatus === 'loading') {
      setScrapingData({
        url: '',
        screenshot: null,
        selectors: [],
        template: null,
        results: []
      });
    }
  };

  const handleTemplateSave = async (template) => {
    try {
      const user = localStorage.getItem("user");
      const userJson = JSON.parse(user);
      const token = userJson.accessToken;

      const response = await fetch(`${apiUrl}/api/scraping/templates`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          template: {
            ...template,
            type: 'scraping_template',
            userId: userJson.id
          }
        })
      });

      if (response.ok) {
        const result = await response.json();
        console.log('Template guardado:', result);
        
        // Actualizar el estado local
        setScrapingData(prev => ({
          ...prev,
          template: result.template
        }));
      } else {
        console.error('Error guardando template');
      }
    } catch (error) {
      console.error('Error guardando template:', error);
    }
  };

  const handleScrapingExecute = async (template) => {
    try {
      const user = localStorage.getItem("user");
      const userJson = JSON.parse(user);
      const token = userJson.accessToken;

      // Enviar mensaje al chat para ejecutar el scraping
      const scrapingMessage = {
        text: `Ejecutar scraping con template: ${template.name}`,
        type: 'scraping_execute',
        template: template,
        agentId: selectedAgent?._id,
        chatId: chatId
      };

      handleChat(scrapingMessage);
      
    } catch (error) {
      console.error('Error ejecutando scraping:', error);
    }
  };

  const filtersDropdownRef = useRef(null);
  const [bottomNext, setBottomNext] = useState(false);
  const minimumDistance = 100;

  useEffect(() => {
    function checkPosicion() {
      if (filtersDropdownRef.current) {
        const rect = filtersDropdownRef.current.getBoundingClientRect();
        const distanciaInferior = window.innerHeight - rect.bottom;
        setBottomNext(distanciaInferior < minimumDistance);
      }
    }

    // Chequea al montar y al hacer scroll/resize
    checkPosicion();
    window.addEventListener("scroll", checkPosicion);
    window.addEventListener("resize", checkPosicion);

    return () => {
      window.removeEventListener("scroll", checkPosicion);
      window.removeEventListener("resize", checkPosicion);
    };
  }, []);

  useEffect(() => {
    if((messages.length > 0 && !bottomNext) || (inputValue.length > 0 && !bottomNext) )setBottomNext(true)
      if(messages.length === 0 && inputValue.length == 0 && bottomNext) setBottomNext(false)
  },[messages,inputValue])





  return (
    <>
      <div
        ref={dragContainerRef}
        className={`${styles.messageDrag} ${!isDragging && styles.hidden}`}
        onDragEnter={handleDragEnter}
        onDragLeave={handleDragLeave}
        onDragOver={handleDragOver}
      >
        <div className={styles.messageDragContainer}>
          {automations.length > 0 && (
            <div className={`${styles.messageDragAgent} ${automations.length <= 4 ? styles.big : ""} ${loadingStates.some((state) => state === "pending") && loadingStates.every((state) => state !== "active") ? styles.loadingMessage : loadingStates.length > 0 && loadingStates.every((state) => state === "active") ? styles.loadedAgent : ""}`} >
              {automations.map((auto, index) => (
                <div
                  key={index}
                  className={styles.messageDragAgentItem}
                  data-automate-type={auto.type}
                  data-automate-name={auto.name}
                  onDrop={(e) => handleDrop(e, auto)}

                >
                  <button
                    className={styles.messageDragAgentItemClose}
                    onClick={() => {
                      setLoadingStates([]);
                      setIsDropping(false);
                      setIsDragging(false);
                    }}
                  >
                    Cancelar
                  </button>
                  <div
                    className={styles.messageDragAgentItemHeader}
                    onClick={() => {
                      dispatch(setShowAutomation(true));
                      navigate(
                        `/admin/chat/${selectedAgent._id}/${chatId}?automation=${auto._id}`,
                        "_blank"
                      );
                    }}
                  >
                    <div className={styles.messageDragAgentItemHeaderIcon}>
                      <img
                        src={
                          automateData?.find((item) => item.type === auto.type)
                            ?.image
                        }
                        alt="icon"
                      />
                    </div>
                    <div className={styles.messageDragAgentItemHeaderContent}>
                      <b>{auto.inputValue}</b>
                      <p>
                        {auto.type}&nbsp;-&nbsp;
                        {
                          automateData?.find((item) => item.type === auto.type)
                            ?.description
                        }
                      </p>
                    </div>
                    <div className={styles.messageDragAgentItemHeaderTags}>
                      <div>
                        <b>
                          {auto?.createdAt &&
                            formatAgoDate({ dateString: auto.createdAt, t })}
                        </b>
                        <IconTag />
                      </div>
                      <div>
                        <IconStar />
                        <div
                          className={styles.messageDragAgentItemHeaderTagsLabel}
                        >
                          <span>{events?.length || "-"}</span>
                          <IconAutomate />
                        </div>
                      </div>
                    </div>
                  </div>
                  <ul
                    className={`${styles.messageDragAgentItemList} ${isDropping ? styles.showList : ""} ${showImportAttachment ? styles.isLoading : ""}`}
                  >
                    {auto.automate?.map((event, index) => (
                      <li
                        key={index}
                        className={`${styles[loadingStates[index]]}`}
                        style={{ "--index": index }}
                      >
                        <label className={styles.loadingBar}></label>
                        <div
                          className={styles.messageDragAgentItemListContainer}
                        >
                          <div
                            className={styles.messageDragAgentItemListNumber}
                          >
                            {index + 1}
                          </div>
                          <div
                            className={styles.messageDragAgentItemListContent}
                          >
                            <p>{renderTextAutomate(event, 'title')}</p>
                            <span>
                              {renderTextAutomate(event)}
                            </span>
                          </div>
                          {event.data?.time > 0 && (
                            <div className={styles.messageDragAgentItemListTags}>
                              {renderTextAutomate(event, 'time')}
                            </div>
                          )}
                        </div>
                      </li>
                    ))}
                  </ul>


                  {isDropping && (
                    <DonutTimer
                      endTime={endTime}
                      color="#16c098"
                    />
                  )}

                  {isDropping && showImportAttachment && (
                    <div className={styles.messageDragAgentItemAlert}>
                      <b>¡Se ha detectado datos ya subidos!</b>
                      <div className={styles.messageDragAgentItemAlertTags}>
                        {auto.automate[3].data?.repeatData?.contacts.length > 0 && (
                          <div className={styles.messageDragAgentItemAlertTag}>
                            {auto.automate[3].data?.repeatData?.contacts.map((contact, index) => (
                              <div
                                key={index}
                                onClick={() => {
                                  navigate(`/admin/contacts/${contact?._id}`)
                                }}
                              >
                                <span>{contact?.contactName || '--'}</span>
                              </div>
                            ))}
                          </div>
                        )}
                        {auto.automate[3].data?.repeatData?.actives.length > 0 && (
                          <div className={styles.messageDragAgentItemAlertTag}>
                            {auto.automate[3].data?.repeatData?.actives.map((active, index) => (
                              <div
                                key={index}
                                onClick={() => {
                                  navigate(`/admin/contacts/${active?._id}`)
                                }}
                              >
                                <span>{active?.name || '--'}</span>
                              </div>
                            ))}
                          </div>
                        )}
                        {auto.automate[3].data?.repeatData?.docs.length > 0 && (
                          <div className={styles.messageDragAgentItemAlertTag}>
                            {auto.automate[3].data?.repeatData?.docs.map((doc, index) => (
                              <div
                                key={index}
                                onClick={() => {
                                  navigate(`/admin/assets/${doc?._id}`)
                                }}
                              >
                                <span>{doc?._id || '--'}</span>
                              </div>
                            ))}
                          </div>
                        )}

                      </div>
                      <p>
                        Estás seguro que quieres importar estos datos
                      </p>
                      <div className={styles.messageDragAgentItemAlertButtons}>
                        <button onClick={() => {
                          setIsDragging(false);
                          setIsDropping(false);
                          setShowImportAttachment(false);
                        }}
                        >
                          Cancelar (N)
                        </button>
                        <button onClick={handleImportData}
                          className={styles.importButton}
                        >
                          Importar (Y)
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
          <div
            ref={attachmentAreaRef}
            className={styles.messageDragAttachment}
            style={{
              display: isDropping ? 'none' : 'flex'
            }}
          >
            <IconAttach />
            <p>Adjuntar el archivo</p>
          </div>
        </div>
      </div>
      <div
        ref={containerRef}
        className={`${styles.chatContainerPage} ${isAgentModal && styles.chatContainerAgent} ${chatAutomate && styles.chatAutomate} ${isDragging && styles.hidden} `}
        onDragEnter={handleDragEnter}
        onDragOver={handleDragOver}
      >
        {JSON.stringify(statusApp)}
        statusAPP
        <div className={`${styles.chatContainer} ${isAgentModal && styles.chatContainerAgent}  ${chatAutomate && styles.chatAutomate} ${statusApp === 'expanded' ? 'expandedApp' : ''}`} >
          <div
            ref={messageContainerRef}
            className={`${styles.messageContainer} ${chatAutomate && styles.messageAutomateContainer}`}
          >
            {activeDateLabel && (
              <div className={styles.stickyDateSeparator}>
                <span>{activeDateLabel}</span>
              </div>
            )}

            {!agentId ? (
              <div className={`${styles.initialMessage}`}>
                {isAgentPopup ? (
                  <div>{t("testYourGpt")}</div>
                ) : inputValue.length >= 1 ? (
                  <h2>{t("howCanHelpYou")}</h2>
                ) : (
                  <>
                    <div className={styles.facturaGPTLogo}>
                      <IconFacturaGPT />
                    </div>
                    <h2 className={styles.singleLine}>
                      {t("getAnswersAndIncreaseYourProductivity")}
                    </h2>
                    <h2 className={styles.lineBreak}>{t("getAnswers")}</h2>
                    <h2
                      className={styles.lineBreak}
                      style={{ marginTop: "0px" }}
                    >
                      {t("increaseYourProductivity")}
                    </h2>
                    <div className={styles.messageSettings}>
                      <p>{t("beforeSpeakingWithFactura")}</p>
                      <span>{t("allNecessaryDataIsPresent")}</span>
                    </div>
                    
                    {/* Añadir botón para iniciar scraping */}
                    <div className={styles.scrapingButtonContainer}>
                      <button
                        onClick={() => setScrapingStatus('loading')}
                        className={styles.scrapingButton}
                      >
                        🕷️ Iniciar Scraping Web
                      </button>
                    </div>
                  </>
                )}
              </div>
            ) : !chatId ? (
              <div className={`${styles.initialMessage}`}>
                <h2>{t("howCanHelpYou")}</h2>
                
                {/* Añadir botón para iniciar scraping */}
                <div className={styles.scrapingButtonContainer}>
                  <button
                    onClick={() => setScrapingStatus('loading')}
                    className={styles.scrapingButton}
                  >
                    🕷️ Iniciar Scraping Web
                  </button>
                </div>
              </div>
            ) : (
              Object.entries(messages).map((messagesForDay) => {
                let dateObj;
                try {
                  dateObj = new Date(messagesForDay[1].timestamp);
                  if (isNaN(dateObj.getTime())) throw new Error("Invalid date");
                } catch (error) {
                  dateObj = new Date();
                }

                const messageDate = format(dateObj, "yyyy-MM-dd");

                let showLabel = false;
                if (messageDate !== lastDateLabel) {
                  showLabel = true;
                  lastDateLabel = messageDate;
                }

                let label = format(dateObj, "MMMM dd, yyyy");
                if (isToday(dateObj)) label = t("today");
                else if (isYesterday(dateObj)) label = t("yesterday");

                return (
                  <div className={styles.dateSeparatorContainer}>
                    {showLabel && (
                      <>
                        <div
                          className={styles.dateSeparatorAnchor}
                          ref={(el) => (observerRefs.current[label] = el)}
                          data-label={label}
                        >
                          <div className={styles.invisibleDateSeparator}>{label}</div>
                        </div>

                        <div
                          className={styles.staticDateLabel}
                          ref={(el) => {
                            if (el) dateLabelRefs.current[label] = el;
                          }}
                        >
                          {label}
                        </div>
                      </>
                    )}

                    {messagesForDay.map((message, index) => (
                      <>
                        {/* {JSON.stringify(message)} */}
                        {message.type == "me" ? (
                          <div className={styles.messageUserContainer}>
                            <div
                              className={`${styles.message} ${styles.userMessage}`}
                            >
                              <div>
                                <p className={styles.userMessageContainer}>
                                  {message.replyId && (
                                    <div
                                      className={styles.replyContainer}
                                      onClick={() =>
                                        checkReplyMessage(message)
                                      }
                                    >
                                      <div>
                                        <b>
                                          Bot &nbsp;
                                          {selectedAgent?.name}
                                        </b>
                                        <p>
                                          {message?.replyId?.text ||
                                            "Message not found"}
                                        </p>
                                      </div>
                                    </div>
                                  )}
                                  {message.isRecord && (
                                    <VoiceMessageBubble
                                      audioBlob={message.isRecord.audioBlob}
                                      samples={message.isRecord.samples}
                                    />
                                  )}
                                  {message?.fileName && (
                                    <div
                                      className={styles.fileContainerMessage}
                                    >
                                      <p>{message?.fileName}</p>
                                      <div
                                        className={styles.iconFileContainer}
                                      >
                                        {imageExtensions.includes(
                                          message?.fileName
                                            ?.split(".")
                                            .pop()
                                            .toLowerCase()
                                        ) ? (
                                          <ImageIcon />
                                        ) : (
                                          <FileIcon />
                                        )}
                                      </div>
                                    </div>
                                  )}

                                  <span className={styles.messageText}>

                                    {safeText(message.text)}
                                  </span>
                                  <span className={styles.date}>
                                    {(() => {
                                      try {
                                        const date = new Date(
                                          message.timestamp
                                        );
                                        if (isNaN(date))
                                          throw new Error("Invalid date");
                                        return date.toLocaleTimeString(
                                          "en-US",
                                          {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            hour12: true,
                                          }
                                        );
                                      } catch {
                                        const now = new Date();
                                        return now.toLocaleTimeString(
                                          "en-US",
                                          {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            hour12: true,
                                          }
                                        );
                                      }
                                    })()}
                                  </span>
                                </p>
                              </div>
                              <div className={styles.avatar}>
                                {user?.profileImage && !imageError ? (
                                  <img
                                    className={styles.profileImage}
                                    src={user.profileImage}
                                    onError={() => setImageError(true)}
                                  />
                                ) : (
                                  <div className={styles.initials}>
                                    {user?.nombre
                                      ?.split(" ")
                                      .map((word) => word[0] || "U")
                                      .slice(0, 2)}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className={styles.optionsBtnMessage}>
                              <BtnOPtionsMessage
                                isBotMessage={false}
                                message={message}
                                chatId={chatId}
                              />
                            </div>
                          </div>
                        ) : message.type == "bot" ? (
                          <div
                            data-timestamp={message.timestamp}
                            className={`${styles.message} ${styles.botMessage}`}
                          >
                            {/* {JSON.stringify(message)} */}
                            <div className={styles.message}>
                              <img
                                src={facturaGPTBlack}
                                className={styles.avatarBot}
                              />
                              {message.docId ? (
                                <div className={styles.isDoc}>
                                  <div className={styles.isDocContainer}>
                                    <div className={styles.docMessage}>
                                      <div className={styles.docMessageHeader}>
                                        <p>📄 Documento generado</p>
                                        <button
                                          className={styles.viewDocButton}
                                          onClick={() => {
                                            console.log('ertyt', message)
                                            dispatch(setMessageDocsShow(true));
                                            dispatch(setMessageDocsData(message.text.html));
                                            dispatch(setMessageDocsDocId(message.docId));
                                          }}
                                        >
                                          Ver documento
                                        </button>
                                      </div>
                                      <div
                                        className={`${styles.docMessageContent} ${expandedMessages.has(message.timestamp) ? styles.docMessageContentShowMore : ''}`}
                                        dangerouslySetInnerHTML={{
                                          __html: message.text.html
                                        }}
                                      />
                                    </div>
                                    <div
                                      onClick={() => {
                                        setExpandedMessages(prev => {
                                          const newSet = new Set(prev);
                                          if (newSet.has(message.timestamp)) {
                                            newSet.delete(message.timestamp);
                                          } else {
                                            newSet.add(message.timestamp);
                                          }
                                          return newSet;
                                        });
                                      }}
                                      className={`${styles.docMessageShowMore} ${expandedMessages.has(message.timestamp) ? styles.docMessageShowMoreShowMore : ''}`}
                                    >
                                      <div>
                                        {expandedMessages.has(message.timestamp) ? 'Show less' : 'Show more'}
                                        <IconArrowDown />
                                      </div>
                                    </div>
                                  </div>
                                  <div className={styles.isDocLogs}>
                                    <ul>
                                      <li>
                                        <b>Cambios.. el texto del usuario</b>
                                        <p>
                                          Hace 10 minutos
                                        </p>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              ) : message.appId ? (
                                <div className={styles.isApp}>
                                  <p className={styles.appHint}>
                                    💡 El preview se actualiza automáticamente cuando editas el código
                                  </p>
                                  <p>
                                    {safeText(message.text)}
                                  </p>
                                  <FileExplorer
                                    appData={safeText(message.text)}
                                    onFileUpdate={handleFileUpdateCallback}
                                    appId={message.appId}
                                    messageTimestamp={message.timestamp}
                                    onFolderSelect={(path) => {
                                      setSelectedFolderPath(path);
                                      setHasUserInteracted(true);
                                      setIsInitialLoad(false);
                                      setHasBeenManuallyTriggered(true);
                                      setShowFolderIndicator(true);
                                    }}
                                    onAppSelect={(appData) => {
                                      setSelectedAppData(appData);
                                      setShowAppIndicator(true);
                                    }}
                                  />
                                </div>
                              ) : message.scrapId ? (
                                <div className={styles.isScraping}>
                                 // Añadir esto en cualquier parte del ChatView para testing
<div className={styles.scrapingButtonContainer}>
  <button
    onClick={() => setScrapingStatus('loading')}
    className={styles.scrapingButton}
  >
    🕷️ Iniciar Scraping Web (TEST)
  </button>
</div>
                                  <ScrapingContainer />
                                  {/* <p>
                                    {message.text}
                                  </p> */}
                                </div>
                              ) : message.isGraph ? (
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: message.text,
                                  }}
                                />
                              ) : message.isApiDelete ? (
                                <div className={styles.isApi}>
                                  <div className={styles.message}>
                                    <p>
                                      {t("followTheSteps")} {safeText(message.text)}.
                                    </p>
                                  </div>
                                  {renderApi(message.text)}
                                </div>
                              ) : message.isApi ? (
                                <MessageApi
                                  web={message.text.url}
                                  timestamp={message.timestamp}
                                  messageContainerRef={messageContainerRef}
                                />
                              ) : message.isAutomate ? (
                                <div className={styles.isAutomate}>

                                  {message.text.status === 500 ? (
                                    <div className={styles.automateCancelled}>
                                      <p>Api scraping cancelled</p>
                                    </div>
                                  ) : (
                                    <>
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: formatWhatsAppText(message?.text?.text),
                                        }}
                                      />
                                      <ul>
                                        {message?.text?.variable?.map((item, index) => {
                                          const isEditing = editingVariableIndices.includes(index);
                                          const editingValue = editingVariableValues[index] || item.value;

                                          return (
                                            <li key={index} className={styles.automateVariable}>
                                              <div>
                                                <b>{item.key || 'not found'}</b>
                                                {!isEditing ? (
                                                  <p>
                                                    {item.value}
                                                  </p>
                                                ) : (
                                                  <input
                                                    value={editingValue}
                                                    onChange={(e) => handleVariableChange(index, e.target.value)}
                                                    data-variable-index={index}
                                                    onKeyDown={(e) => handleVariableKeyDown(e, index)}
                                                    onBlur={() => handleVariableSave(index)}
                                                    autoFocus
                                                  />
                                                )}

                                                {!isEditing && (
                                                  <button
                                                    className={styles.buttonIcon}
                                                    onClick={() => toggleVariableEditing(index, item.value)}
                                                  >
                                                    <IconEdit />
                                                  </button>
                                                )}
                                              </div>
                                              <div>
                                                <button className={styles.buttonIcon} >
                                                  <IconVerify />
                                                </button>
                                                {isEditing && (
                                                  <button
                                                    className={styles.saveButton}
                                                    onClick={() => handleVariableSave(index)}
                                                  >
                                                    Guardar
                                                  </button>
                                                )}
                                              </div>
                                            </li>
                                          )
                                        })}
                                      </ul>
                                      <ul style={{ marginLeft: '20px' }}>
                                        {message?.text?.action?.map((item, index) => (
                                          <li
                                            key={index}
                                            className={styles.automateItem}
                                            onClick={() => {
                                              const fn = `fn-${item.fn}`

                                              handleSendMessage({
                                                text: fn,
                                                type: 'fn',
                                                timestamp: message?.timestamp,
                                                agentName: selectedAgent?.name,
                                                agentId: selectedAgent?._id,
                                              })
                                            }}
                                          >
                                            <div className={styles.automateItemIcon} >
                                              {item.icon}
                                            </div>
                                            <div className={styles.automateItemContent} >
                                              <b>
                                                {item.title}
                                              </b>
                                              <p>
                                                {item.description}
                                              </p>
                                            </div>
                                            {/* {item.prompt} */}
                                          </li>
                                        ))}
                                      </ul>
                                    </>
                                  )}

                                </div>
                              ) : message.isAutomate1 ? (
                                <div
                                  className={styles.messageAutomateItem}
                                  onClick={() => {
                                    dispatch(setShowAutomation(true));
                                    navigate(
                                      `/admin/chat/${selectedAgent._id}/${chatId}?automation=${message?.text?.find((item) => item.type === "automate")?.data?.id}`,
                                      "_blank"
                                    );
                                  }}
                                >
                                  <div className={styles.messageAutomateItemHeader} >
                                    <div className={styles.messageAutomateItemHeaderIcon} >
                                      <img src={automateData?.find((item) => item.type === message?.text?.find((item) => item.type === "automate")?.data?.type)?.image} alt="icon" />
                                    </div>
                                    <div className={styles.messageAutomateItemHeaderContent} >
                                      <b>
                                        {message?.text?.find((item) => item.type === "automate")?.data?.name || "-"}
                                      </b>
                                      <p>
                                        {automateData?.find((item) => item.type === message?.text?.find((item) => item.type === "automate")?.data?.type)?.description}
                                      </p>
                                    </div>
                                    <div className={styles.messageAutomateItemHeaderTags} >
                                      <div>
                                        <b>
                                          {message?.timestamp && formatAgoDate({ dateString: message?.timestamp, t, })}
                                        </b>
                                        <IconStar />
                                      </div>
                                      <div>
                                        <div className={styles.messageAutomateItemHeaderTagsLabel} >
                                          <span>
                                            {message?.text?.length || "-"}
                                          </span>
                                          <IconAutomate />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <ul
                                    className={`${styles.messageAutomateItemList} `}
                                  >
                                    {message?.text?.map(
                                      (event, index) => (
                                        <li
                                          key={index}
                                          className={`${styles[loadingStates[index]]}`}
                                          style={{ "--index": index }}
                                        >
                                          <label className={styles.loadingBar} ></label>
                                          <div className={styles.messageAutomateItemListContainer} >
                                            <div className={styles.messageAutomateItemListNumber} >
                                              {index + 1}
                                            </div>
                                            <div className={styles.messageAutomateItemListContent} >
                                              <p>{renderTextAutomate(event, 'title')}</p>
                                              <span>
                                                {renderTextAutomate(event)}
                                              </span>
                                            </div>
                                            {event.data?.time > 0 && (
                                              <div className={styles.messageAutomateItemListTags} >
                                                {renderTextAutomate(event, 'time')}
                                              </div>
                                            )}
                                          </div>
                                        </li>
                                      )
                                    )}
                                  </ul>
                                </div>
                              ) : message.isAction ? (
                                <div className={`${styles.isAction} ${message.text.length >= 4 ? styles.big : ""}`} >
                                  {message.text.map((item, index) => (
                                    <div
                                      key={index}
                                      onMouseEnter={() => {
                                        const isMuted =
                                          localStorage.getItem(
                                            "mutedSound"
                                          ) === "true";

                                        if (!isMuted) {
                                          window.speechSynthesis.cancel();

                                          const utterance =
                                            new SpeechSynthesisUtterance(
                                              item.text
                                            );
                                          utterance.lang = "es-ES";
                                          window.speechSynthesis.speak(
                                            utterance
                                          );
                                        }
                                      }}
                                      onMouseLeave={() => {

                                        window.speechSynthesis.cancel();
                                      }}
                                    >
                                      <div>{item.icon}</div>
                                      <span>{item.title}</span>
                                      <p>{item.text}</p>
                                    </div>
                                  ))}
                                </div>
                              ) : message.isTable ? (
                                <div className={styles.isTable}>
                                  <p>
                                    {message.text.text}
                                  </p>
                                  <DynamicTable
                                    columns={[
                                      {
                                        label: "Nombre",
                                        key: "name",
                                      },
                                      {
                                        label: "Email",
                                        key: "email",
                                      },
                                      {
                                        label: "Phone",
                                        key: "phone",
                                      },
                                    ]}
                                    ref={dynamicTableRef}
                                    data={[
                                      {
                                        name: "FacturaGPT",
                                        email: "FacturaGPT@example.com",
                                        phone: "123-123-123",
                                      },
                                      {
                                        name: "John Doe",
                                        email: "john.doe@example.com",
                                        phone: "123-456-7890",
                                      },
                                      {
                                        name: "facturagpt",
                                        email: "facturagpt@example.com",
                                        phone: "666-666-666",
                                      },

                                    ]}
                                    renderRow={(item) => {
                                      return (
                                        <tr>
                                          <td style={{ position: "static", }} >
                                            <div className={styles.inputWrapperHover} >
                                              <input
                                                type="checkbox"
                                                name="accountSelected"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                }}
                                              />
                                              <div className={styles.inputContainer} ></div>
                                            </div>
                                          </td>
                                          <td>{item.name}</td>
                                          <td>{item.email}</td>
                                          <td>{item.phone}</td>
                                        </tr>
                                      );
                                    }}
                                    selectedIds={[]}
                                    onSelectAll={() => { }}
                                    onSelect={() => { }}
                                    typeTable={'contacts'}
                                    saveTable={true}
                                  />
                                </div>
                              ) : message.isImage ? (
                                <div className={styles.isImage}>
                                  <img src={safeText(message.text)} alt="image" />
                                </div>
                              ) : message.isAudio ? (
                                <div className={styles.isAudio}>
                                  <audio
                                    src={safeText(message.text)}
                                    controls
                                    controlsList="nodownload"
                                    autoPlay
                                  />
                                </div>
                              ) : message.isOnline ? (
                                <HighlightedText
                                  text={message.text?.text}
                                  annotations={message.text?.annotations}
                                />
                              ) : message.isViewer ? (
                                <ViewerContainer message={message} />
                              ) : (
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: formatWhatsAppText(message.text),
                                  }}
                                />
                              )}
                            </div>
                            <div className={styles.optionsBtnMessage}>
                              <BtnOPtionsMessage
                                isBotMessage={true}
                                message={message}
                                chatId={chatId}
                                setShowReply={setShowReply}
                              />
                            </div>
                          </div>
                        ) : null}
                      </>
                    ))}
                  </div>
                );
              }
              )
            )}
            {chatAutomate && messages.length == 0 && (
              <CreateApiConnection selectedAutomate={selectedAutomateChat} />
            )}
            {messages && messages?.at(-1)?.type === "me" && (
              <div className={`${styles.message} ${styles.botMessage}`}>
                <div className={styles.message}>
                  <img src={facturaGPTBlack} className={styles.avatarBot} />
                  <div className={styles.isApi}>
                    <div
                      style={{ marginBottom: "0px" }}
                      className={styles.message}
                    >
                      <p>
                        <div className={styles.dotsContainer}>
                          <span className={styles.dot}>.</span>
                          <span className={styles.dot}>.</span>
                          <span className={styles.dot}>.</span>
                        </div>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {false && (
              <div className={`${styles.message} ${styles.botMessage}`}>
                <img src={facturaGPTWhite} className={styles.avatar} />
                <p>{t("loading")}</p>
              </div>
            )}
          </div>

          {selectedAgent?.instructions?.length > 0 &&
            messages?.length === 0 && (
              <div className={styles.buttonContainer}>
                {selectedAgent.instructions.map((instruction, index) => (
                  <button
                    key={index}
                    onClick={() =>
                      handleChat({
                        text: instruction.title,
                        agent: selectedAgent?.name,
                      })
                    }
                  >
                    {instruction.title}
                  </button>
                ))}
              </div>
            )}

          {isAgentPopup
            ? userData?.instructions &&
            messages?.length === 0 && (
              <div className={styles.buttonContainer}>
                {userData?.instructions.map((instruction, index) => (
                  <button key={index}>{instruction.title}</button>
                ))}
              </div>
            )
            : null}

          <div
            ref={chatTextContainerRef}
            className={`${styles.chatTextContainer} ${messages?.length >= 1 && styles.chatTextContainerEnd}`}
          >
            <div className={styles.infoChunck}>
              {showInfoMessage && (
                <div>
                  {!isNaN(timeToFinishResponse) && (
                    <span>{(timeToFinishResponse / 1000).toFixed(3)} s</span>
                  )}
                  <span>
                    {" "}
                    <Arrow className={styles.upArrow} />
                    {tokenInput}{" "}
                  </span>
                  <span>
                    {" "}
                    <Arrow className={styles.downArrow} />
                    {tokenOutput}{" "}
                  </span>
                </div>
              )}
            </div>
            <>
              {showVoiceRecorder && (
                <VoiceRecorderWave
                  onSend={handleSendVoice}
                  onCancel={() => setShowVoiceRecorder(false)}
                  ref={recorderRef}

                />
              )}
              <div
                className={`${styles.chatTextAreaContainer} ${isLoadBot && styles.chatContainerBorderAnimation}`}
                onDragOver={(e) => e.preventDefault()}
                onDrop={(e) => {
                  e.preventDefault();
                  const files = e.dataTransfer.files;
                  if (files && files.length > 0) {
                    const file = files[0];
                    
                    const isPDF =
                      file.type === "application/pdf" ||
                      file.name.toLowerCase().endsWith(".pdf");

                    if (!isPDF) {
                      alert("Solo se permiten archivos PDF.");
                      return;
                    }

                    handleFileChange({ target: { files } });
                  }
                }}
              >
                {containsArroba && (
                  <ContactsPopup
                    ref={contactsRef}
                    handleSelectItem={handleSelectItem}
                    type={"chat"}
                    inputValue={inputValue.split("@").pop()}
                    customStyle={{
                      top: "initial",
                      bottom: "100%",
                      width: "55%",
                      padding: "4px",
                      maxWidth: "270px",
                      background: "#fafafa",
                      boxShadow: "0 2px 10px #0000001a",
                      gap: "0px",
                    }}
                    handleClickFocus={handleClickFocus}
                  />
                )}
                {inputValue && (
                  <div
                    style={{
                      transform: `translateY(-${scrollTop - 2}px)`,
                    }}
                    className={`${styles.highlight}`}
                    aria-hidden="true"
                  >
                    {parseText(inputValue)}
                  </div>
                )}

                {showReply?.text && (
                  <div className={styles.replyContainer}>
                    <div>
                      <b>
                        Bot &nbsp;
                        {selectedAgent?.name}
                      </b>
                      <p>{showReply?.text || "Message not found"}</p>
                    </div>
                    <button onClick={() => setShowReply(false)}>
                      <IconClose />
                    </button>
                  </div>
                )}

                {/* Section Indicator */}
                {selectedSectionId && (
                  <div className={styles.sectionIndicator}>
                    <div className={styles.sectionInfo}>
                      <span className={styles.sectionId}>📄 {selectedSectionId.substring(0, 8)}...</span>
                      <div className={styles.sectionActions}>
                        <button
                          className={styles.sectionActionBtn}
                          onClick={() => {
                            // Navigate to previous section
                            navigateToSection('prev');
                          }}
                          title="Previous Section (↑)"
                        >
                          ↑
                        </button>
                        <button
                          className={styles.sectionActionBtn}
                          onClick={() => {
                            // Navigate to next section
                            navigateToSection('next');
                          }}
                          title="Next Section (↓)"
                        >
                          ↓
                        </button>
                        <button
                          className={styles.sectionActionBtn}
                          onClick={() => dispatch(setMessageDocsSelectedSection(null))}
                          title="Clear Selection (Esc)"
                        >
                          ✕
                        </button>
                      </div>
                    </div>
                    <div className={styles.sectionLogs}>
                      <ul>
                        <li>
                          {true ? (
                            <IconVerify />
                          ) : (
                            <IconCancel />
                          )}
                          <p>
                            Cambios.. el texto del usuario
                          </p>
                          <b>
                            Hace 10 minutos
                          </b>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}




                {/* Folder Indicator */}
                {showFolderIndicator && (
                  <div className={styles.folderIndicatorContainer}>
                    <FolderIndicator
                      selectedPath={selectedFolderPath}
                      isVisible={showFolderIndicator}
                      onClose={() => setShowFolderIndicator(false)}
                      onAddDocument={handleAddDocument}
                      onOpenChat={handleOpenChatInChatView}
                    />
                  </div>
                )}

                {/* App Indicator */}
                {showAppIndicator && (
                  <div className={styles.appIndicatorContainer}>
                    <AppIndicator
                      appData={selectedAppData}
                      isVisible={showAppIndicator}
                      onClose={() => setShowAppIndicator(false)}
                    />
                  </div>
                )}
                
                <textarea
                  ref={textareaRef}
                  spellCheck="false"
                  type="text"
                  placeholder={
                    selectedAgent
                      ? t("talkWith") + " " + selectedAgent?.name
                      : t("talkToFacturaGPT")
                  }
                  value={inputValue}
                  onFocus={() => setIsFocused(true)}
                  onBlur={(e) => {
                    setIsFocused(false);
                    handleBlur(e);
                  }}
                  onChange={(e) => {
                    setInputValue(e.target.value);
                    setShowInfoMessage(false);

                    // Si el usuario está escribiendo manualmente y no está navegando por memoria,
                    // resetear el índice de navegación
                    if (!isNavigatingHistory) {
                      setHistoryIndex(messageHistory.length);
                    }

                    // Si el usuario borra todo el texto, permitir navegación
                    if (e.target.value === '') {
                      setIsNavigatingHistory(false);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.ctrlKey || e.altKey) {
                      e.stopPropagation();
                      // e.preventDefault();
                      return;
                    }

                    // Prevent Shift+/ from opening chat explorer when in textarea
                    if (e.shiftKey && e.key === "/") {
                      e.stopPropagation();
                      return;
                    }

                    // Navegación por la memoria de mensajes
                    if (e.key === "ArrowUp" && !e.shiftKey && !e.ctrlKey && !e.altKey) {
                      e.preventDefault();
                      navigateHistoryUp();
                      return;
                    }

                    if (e.key === "ArrowDown" && !e.shiftKey && !e.ctrlKey && !e.altKey) {
                      e.preventDefault();
                      navigateHistoryDown();
                      return;
                    }

                    // Si el usuario está escribiendo, desactivar la navegación por memoria
                    if (e.key !== "ArrowUp" && e.key !== "ArrowDown" && e.key !== "Enter") {
                      setIsNavigatingHistory(false);
                    }

                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault();

                      // Guardar el mensaje en la memoria antes de enviarlo
                      if (inputValue && inputValue.trim() !== '') {
                        saveMessageToHistory(inputValue);
                      }

                      setInputValue("");
                      setIsPaused(false);
                      setTokenInput(inputValue?.length);

                      if (itemsSelected?.length > 0) {

                        // text = [{
                        //   text: 'part1',
                        //   indice: {
                        //     start: 10,
                        //     end: 235
                        //   }
                        // }]

                        const items = itemsSelected.map(item => {
                          if (item.contactName) {
                            return {
                              id: item._id,
                              type: 'contact',
                            }
                          } else {
                            return {
                              id: item._id,
                              type: 'asset',
                            }
                          }
                        })

                        handleSendMessage({
                          text: inputValue,
                          agentName: selectedAgent?.name,
                          agentId: selectedAgent?._id,
                          isRAG: items,
                          // docId: {
                          //   id: '123',
                          //   html: '<h2>hello world</h2>'
                          // }
                        });
                      } else {
                        handleChat({
                          text: inputValue,
                          agent: selectedAgent?.name,
                          agentId: selectedAgent?._id,
                          file: filePayload,
                        });
                      }

                      setFilePayload(null);
                      setFileInfo(null);
                      setItemsSelected([])

                    }
                  }}
                />

                {fileInfo && (
                  <div className={styles.fileContainer}>
                    <div
                      className={styles.deleteFileButton}
                      onClick={() => {
                        setFilePayload(null);
                        setFileInfo(null);
                      }}
                    >
                      X
                    </div>
                    <div className={styles.iconFileContainer}>
                      {imageExtensions.includes(
                        fileInfo.name.split(".").pop().toLowerCase()
                      ) ? (
                        <ImageIcon />
                      ) : (
                        <FileIcon />
                      )}
                    </div>
                    <div>
                      <p>{fileInfo.name}</p>
                      <span>{fileInfo.name.split(".").pop()}</span>
                    </div>
                  </div>
                )}

                <div className={styles.optionsChat}>
                  <div>
                    <button
                      data-tooltip={t("moreOptionsHere")}
                      onClick={() => setIsOpen((prev) => !prev)}
                    >
                      <AddPlus
                        style={{
                          height: "14px",
                          width: "14px",
                        }}
                      />
                    </button>
                    {inputValue && !isAgentPopup && (
                      <>
                        <button
                          data-tooltip={t("searchTheWeb")}
                          onClick={searchInWebFn}
                        >
                          <InternetIconChat
                            className={searchInWeb && styles.activeIcon}
                          />
                        </button>

                        {isOpen && (
                          <FloatingMenu
                            isOpen={isOpen}
                            setIsOpen={setIsOpen}
                            openModalAutomate={openModalAutomate}
                            closeModalAutomate={closeModalAutomate}
                            showCreateFolder={showCreateFolder}
                            setShowCreateFolder={setShowCreateFolder}
                            showNewTagModal={showNewTagModal}
                            setShowNewTagModal={setShowNewTagModal}
                            showNewContact={showNewContact}
                            setShowNewContact={setShowNewContact}
                            showNewProduct={showNewProduct}
                            setShowNewProduct={setShowNewProduct}
                            setShowNewBill={setShowNewBill}
                            setShowUplaodFile={setShowUplaodFile}
                            setShowLocationModal={setShowLocationModal}
                            customPosition={{
                              top: "initial",
                              bottom: "80px",
                              left: "450px",
                              height: "fit-content",
                              width: "fit-content",
                              flexDirection: "column-reverse",
                            }}
                          />
                        )}


                      </>
                    )}
                    <input
                      ref={fileInputRef}
                      type="file"
                      accept=".pdf, .jpg, .jpeg, .xlsx,.png, .jpg, j.peg, .gif, .bmp, .svg, .webp"
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                    />

                    <button
                      data-tooltip={t("attachFile")}
                      onClick={handleButtonClick}
                    >
                      <BlackClip />
                    </button>
                    <button
                      data-tooltip={
                        !isListening ? t("speakByVoice") : t("stopVoice")
                      }
                      onClick={handleClick}
                      onMouseLeave={() => {
                        if (voiceChat) startCountdown();
                      }}
                      onMouseEnter={cancelCountdown}
                    >
                      <AudioWaves
                        isRecording={voiceChat}
                        setIsRecording={setVoiceChat}
                      />
                      {countdownNumber && (
                        <span className={styles.notificationTotal}>
                          {countdownNumber}
                        </span>
                      )}
                    </button>
                    <button
                      data-tooltip={muted ? t("muteSound") : t("unMuteSound")}
                      onClick={handleToggleSound}
                    >
                      {!muted ? <SoundOnIcon /> : <SoundOffIcon />}
                    </button>

                    <button
                      onClick={() => {

                        setShowVoiceRecorder((v) => !v)
                      }}
                      data-tooltip={t('voiceWave')}
                    >
                      <BlackMicrophone />
                    </button>

                    {showVoiceRecorder && (
                      <>
                        {!hasStoppedRecording && (
                          <button onClick={() => {
                            recorderRef.current?.stopRecording()
                          }} data-tooltip={t('stop')}>⏹️</button>
                        )}

                        {hasStoppedRecording && (
                          isPlaying ? (
                            <button onClick={() => {
                              recorderRef.current?.handlePause()
                            }} data-tooltip={t('pause')}>⏸️ </button>
                          ) : (
                            <button onClick={() => {
                              recorderRef.current?.handlePlay()
                            }} data-tooltip={t('play')}>▶️ </button>
                          )
                        )}

                        <button onClick={() => {
                          recorderRef.current?.handleCancel()
                        }} data-tooltip={t('delete')}>🗑️ </button>

                        {hasStoppedRecording && (
                          <button
                            onClick={async () => {
                              const recorder = recorderRef.current;
                              if (!recorder) return;

                              if (isRecording) {
                                recorder.stopRecording();
                              }

                              await recorder.sendRecording();
                            }} data-tooltip={t('send')}
                          >
                            📤
                          </button>
                        )}
                      </>
                    )}






                  </div>
                  <div>
                    {messages?.length >= 1 && (
                      <div
                        onClick={restartLastMessageFn}
                        className={styles.restartButton}
                        style={{
                          color: autoClear && "black",
                        }}
                      >
                        Auto-clear
                      </div>
                    )}
                    {(showReply?.text ||
                      inputValue.length >= 1 ||
                      (isLoadBot && !finishedResponseBot)) && (
                        <button
                          data-tooltip={
                            !isLoadBot ? t("sendMessage") : isPaused ? t("resumeChat") : t("pauseChat")
                          }
                          className={`${styles.sendMessageBtn}`}
                          onClick={() => {
                            console.log('isLoadBotisLoadBot', isLoadBot)
                            if (!isLoadBot) {
                              handleChat({
                                text: inputValue,
                                agent: selectedAgent?.name,
                                agentId: selectedAgent?._id,
                                file: filePayload,
                              });
                              // setFilePayload(null);
                              // setFileInfo(null);
                            } else {
                              setIsPaused((prev) => !prev);
                            }
                          }}
                        >
                          {(!isLoadBot || isPaused) ? (
                            <ArrowUp className={styles.ArrowUp} />
                          ) : (
                            <PauseIcon className={styles.PauseIcon} />
                          )}
                        </button>
                      )}
                  </div>
                </div>
                {messages?.length === 0 &&
                  inputValue &&
                  isFocused &&
                  !isAgentPopup && (
                    <div className={styles.recommendesQuestionsContainer}>
                      <div className={styles.recomendQuestions}>
                        {recommendedQuestions.map((text, index) => {
                          const normalizedText = text
                            .normalize("NFD")
                            .replace(/[\u0300-\u036f]/g, "")
                            .toLowerCase();

                          const normalizedInputValue = inputValue
                            .normalize("NFD")
                            .replace(/[\u0300-\u036f]/g, "")
                            .toLowerCase();

                          const forwardMatchIndex =
                            normalizedText.indexOf(normalizedInputValue);

                          const backwardMatchIndex =
                            normalizedText.lastIndexOf(normalizedInputValue);

                          if (
                            forwardMatchIndex === -1 &&
                            backwardMatchIndex === -1
                          ) {
                            return null;
                          }

                          const matchIndex =
                            forwardMatchIndex !== -1
                              ? forwardMatchIndex
                              : backwardMatchIndex;
                          const matchLength = inputValue.length;

                          return (
                            <div
                              key={index}
                              onMouseDown={() =>
                                handleChat({
                                  text: text,
                                  agent: selectedAgent?.name,
                                })
                              }
                            >
                              <p className={`${styles.textBlack}`}>
                                <span className={`${styles.textBlack}`}>
                                  {text.slice(0, matchIndex)}
                                </span>

                                <span className={`${styles.textBlack}`}>
                                  {text.slice(
                                    matchIndex,
                                    matchIndex + matchLength
                                  )}
                                </span>

                                {text.slice(matchIndex + matchLength)}
                              </p>
                              <Arrow />
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                {tokens?.tokens?.length > 0 &&
                  <div ref={filtersDropdownRef}  style={{ position: "relative" }}>
                    <div style={{ position: "absolute", right: "-15px", top: "3px" }}>
                      <FiltersDropdownContainer
                      customDropdownOptions={{bottom: "100%", marginBottom:" 4px", marginTop: "0px"}}
                      bottomNext={bottomNext}
                        setSelectedFilters={setSelectedOption}
                        selectedFilters={selectedOption}
                        options={optionsFiltered}
                        father={"chatToken"}
                      />

                      {/* <CustomDropdown
                height="25px"
        options={options}
        selectedOption={<>
  <TokenOpenAI/> {selectedOption?.token.slice(0,15)}
  </>}
        setSelectedOption={(option) => tokenSelected(option)}
        father={"ChatToken"}
        type={'token'}
                /> */}
                    </div>
                  </div>}
              </div>
            </>
            {!isAgentPopup && renderMessage()}
          </div>

          {tokens?.tokens?.length > 0 && <div style={{ height: "25px" }}></div>}

          {shouldRenderActions && !hiddeCarousel &&
            (windowWidth >= 768 ? (
              <div className={styles.buttonContainer}>
                {actions.map((action, index) => (
                  <button
                    key={index}
                    onClick={() =>
                      handleChat({
                        text: action.text,
                        agent: selectedAgent?.name,
                        id: action?.id,
                      })
                    }
                  >
                    <img src={action.img} alt="Icon" />
                    {action.text}
                    <GrayDiagonalArrow />
                  </button>
                ))}
              </div>
            ) : (
              <Scroller
                direction="left"
                speed="slow"
                handleChat={handleChat}
                isArray={true}
                content={actions}
                selectedAgent={selectedAgent}
                alone={true}
              />
            ))}

          {!inputValue && !hiddeCarousel &&
            messages?.length === 0 &&
            !isAgentPopup &&
            shouldRenderActions && <ChatTags handleChat={handleChat} />}

          {isAgentPopup && (
            <div className={styles.footerChat}>
              <div className={styles.languageContainer}>
                {languageFlags.map((item) => (
                  <span
                    key={item.code || item.value}
                    className={styles.dropdownItem}
                    onClick={() => {
                      i18n.changeLanguage(item.label);
                    }}
                  >
                    {item.label}
                  </span>
                ))}
              </div>
              <div className={styles.linksContainerFooterChat}>
                <a href="/terms">{t("cookies")}</a>
                <a href="/terms">{t("privacy")}</a>
                <a href="/home">{t("home")}</a>
                <a href="/contact">{t("more")}</a>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

const ChatView = ({ }) => {
  const [t] = useTranslation(["ChatView", "Preview"]);
  const { agentId, chatId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { selectedSectionId } = useSelector((state) => state.docs);

  const [menuOpenChat, setMenuOpenChat] = useState(false);
  // const [showDeleteChatsAgents, setShowDeleteChatsAgents] = useState(false);
  // const [typeDeleteChatsAgents, setSTypeDeleteChatsAgents] = useState(null);
  // const [varianteDeleteChatsAgent, setVarianteDeleteChatsAgent] = useState('confirm')
  const [messages, setMessages] = useState([]);
  const [inputValue, setInputValue] = useState(``);
  // const [selectedAgent, setSelectedAgent] = useState(null);
  // const [selectedLanguage, setlanguage] = useState(null);
  // const [selectedChatAgentToDelete, setSelectedChatAgentToDelete] = useState(null);
  const { selectedAgent, currentChat, loading, chatList, setChatList, emptyChat } = useSelector((state) => state.chat);

  const [chatAgentId, setChatAgentId] = useState(null);
  // const [chats, setChats] = useState([]);
  const { question, user, totalNotification, showAutomation, tokens } = useSelector((state) => state.user, shallowEqual);
  const location = useLocation();
  const [newChat, setNewChat] = useState()
  const [containsArroba, setContainsArroba] = useState(null)
  const [arrobaCount, setArrobaCount] = useState(0)
  const [selectItemCount, setSelectItemCount] = useState(0)
  const [showMiniProfileModal, setShowMiniProfileModal] = useState()
  const [itemsSelected, setItemsSelected] = useState([])
  // const { rowId, selectedAgentState } = location.state || {};

  const [isLoadBot, setIsLoadBot] = useState(false);
  const [showCorporativeModal, setShowCorporativeModal] = useState(false);
  const [corporativeTitle, setCorporativeTitle] = useState("");
  const [corporativeMessage, setCorporativeMessage] = useState("");
  const [autoClear, setAutoClear] = useState(false)
  const [searchInWeb, setSearchInWeb] = useState(false)
  // const [groupedMessages, setGroupedMessages] = useState([])
  const [filePayload, setFilePayload] = useState(null);
  const [tokenInput, setTokenInput] = useState(0)
  const [tokenOutput, setTokenOutput] = useState(0)
  const [timeToFinishResponse, setTimeToFinishResponse] = useState(0)
  const [finishedResponseBot, setFinishedResponseBot] = useState(false)
  const [showInfoMessage, setShowInfoMessage] = useState(false)

  // const [showNewContact, setShowNewContact] = useState(false);
  // const [initialChatTriggered, setInitialChatTriggered] = useState(false);


  const [windowWidth, setWindowWidth] = useState(window.innerWidth);


  const [leftWidth, setLeftWidth] = useState(200);
  const isResizing = useRef(false);
  const startX = useRef(0);

  const [showNewAgent, setShowNewAgent] = useState(
    location.state?.showAgent || false
  );
  // const [swiped, setSwiped] = useState(false);
  const [idSelectedAgent, setIdSelectedAgent] = useState(null);
  const [userData, setUserData] = useState({
    Capabilities: [],
    pinned: false,
    tone: 3,
    answer: 3,
  });
  // const [selectedFileS3, setSelectedFileS3] = useState(null);
  // const [fileNameS3, setFileNameS3] = useState(null);

  // const isMobile = windowWidth <= 768;

  const handleSelectItem = (item) => {
    const prev = inputValue.split("@").slice(0, -1).join("@")
    setInputValue(`${prev}@${item.name ? item.name : item.contactName ? item.contactName : "not found"}`)
    setSelectItemCount(selectItemCount + 1)
    setItemsSelected([...itemsSelected, item])
  }

  const [isPaused, setIsPaused] = useState(false);
  // const [stateAutomate, setStateAutomate] = useState(null)


  const isPausedRef = useRef(false);

  useEffect(() => {
    isPausedRef.current = isPaused;
  }, [isPaused]);


  // const waitWhilePaused = async () => {
  //   while (isPausedRef.current) {
  //     await new Promise(resolve => setTimeout(resolve, 200));
  //   }
  // };


  const [showReply, setShowReply] = useState({});

  const readerMessageRef = useRef(null);

  const {
     searchTerm: searchTermState
  } = useSelector((state) => state.chat);

  const handleSendMessage = async ({
    text = false,
    type,
    timestamp,
    agentName,
    agentId,
    record,
    isRAG,
    file,
    newChat,
  }) => {

    if (readerMessageRef.current) {
      readerMessageRef.current.cancel();
      readerMessageRef.current = null;
    }


    if (agentName == "" || agentName == undefined) {
      setShowCorporativeModal(true);
      setCorporativeTitle(t("itIsNecessarySelectAgent"));
      setCorporativeMessage(t("selectAgentToEnableMessage"));
      return;
    }
    try {
      setShowReply({})
      setIsLoadBot(true);
      setFinishedResponseBot(false)

      // const lastMessage = messages[messages.length - 1]

      // const lastMessage = messages.pop()
      // const lastBotMessage = messages.filter(message => message.type === 'bot').pop()


      // if (autoClear && !lastMessage?.threadId) {
      if (autoClear && type !== 'fn') {
        setMessages([])
      }


      console.log('type', type)

      if (type !== 'fn' && (text || showReply?.timestamp || record)) {
        console.log('erftghythgthtrfdef')
        setMessages((prevMessages) => {
          const newMessages = [
            ...prevMessages,
            {

              text: text || "",
              // type: "me",
              type: type || "me",
              agent: agentName,
              fileName: file?.name,
              fileType: file?.type,
              ...(timestamp && { timestamp: timestamp }),
              ...(isRAG && { isRAG: isRAG }),
              ...(showReply.timestamp && { replyId: showReply }),
              ...(record && { isRecord: record }),
            },
          ];

          return newMessages;
        });

        setInputValue("");
      }


      const userStorage = localStorage.getItem("user");

      const userJson = JSON.parse(userStorage);
      const token = userJson.accessToken;
      const new_id = uuidv4();
      let selectedChat;

      if (!chatId) selectedChat = new_id;
      else selectedChat = chatId;

      navigate(`/admin/chat/${agentId}/${selectedChat}`);

      let threadId = null
      let docId = null
      let appId = null
      let scrapId = null

      console.log('last message', messages[messages.length - 1])
      if (newChat) {
        setMessages("");
      } else {
        const lastMessage = messages[messages.length - 1]
        threadId = lastMessage?.threadId || null
        docId = lastMessage?.docId || null
        appId = lastMessage?.appId || null
        scrapId = lastMessage?.scrapId || null
      }

      // Si existe selectedSectionId, modificar el docId
      if (selectedSectionId) {
        docId = `docId_${selectedSectionId}`
        console.log('Enviando docId con sección:', docId)
      }

      const startTime = Date.now();

      await fetch(`${apiUrl}/api/chat/${selectedAgent._id}/${selectedChat}/messages`, {
        method: "POST",
        body: JSON.stringify({
          text: text,
          file: file,
          ...(timestamp && { timestamp: timestamp }),
          ...(type && { type: type }),
          ...(record && { record: record }),
          ...(isRAG && { isRAG: isRAG }),
          ...(showReply.timestamp && { replyId: showReply }),
          ...(threadId && { threadId: threadId }),
          ...(docId && { docId: docId }),
          ...(appId && { appId: appId }),
          ...(scrapId && { scrapId: scrapId }),
        }),
        headers: {
          "Content-Type": "application/octet-stream",
          Authorization: `Bearer ${token}`,
        },
      }).then((response) => {

        if (response.ok) {
          // const reader = response.body.getReader();
          readerMessageRef.current = response.body.getReader();

          const decoder = new TextDecoder();
          let accumulatedChunks = "";
          let accumulatedText = "";

          const insertMessage = ({
            text,
            timestamp,
            threadId,
            docId,
            appId,
            scrapId,
            replyId,
            isRecord,
            isGraph,
            isApi,
            isAction,
            isTable,
            isAutomate,
            isAsset,
            isImage,
            isAudio,
            isOnline,
            isViewer,
          }) => {
            setMessages((prevMessages) => {
              const newMessages = [...prevMessages];

              if (appId || docId || isRAG || isAction || isTable || isAutomate || isAsset || isImage || isAudio || isOnline || isGraph || isApi || isViewer) {
                accumulatedText = text;
              } else {
                accumulatedText += text;
              }

              if (
                newMessages.length > 0 &&
                newMessages[newMessages.length - 1].type === "bot"
              ) {
                newMessages[newMessages.length - 1].text = accumulatedText;
                isRecord && (newMessages[newMessages.length - 1].isRecord = isRecord);
                isGraph && (newMessages[newMessages.length - 1].isGraph = isGraph);
                isApi && (newMessages[newMessages.length - 1].isApi = isApi);
                isAction && (newMessages[newMessages.length - 1].isAction = isAction);
                isTable && (newMessages[newMessages.length - 1].isTable = isTable);
                isAutomate && (newMessages[newMessages.length - 1].isAutomate = isAutomate);
                isAsset && (newMessages[newMessages.length - 1].isAsset = isAsset);
                isImage && (newMessages[newMessages.length - 1].isImage = isImage);
                isAudio && (newMessages[newMessages.length - 1].isAudio = isAudio);
                isOnline && (newMessages[newMessages.length - 1].isOnline = isOnline);
                isViewer && (newMessages[newMessages.length - 1].isViewer = isViewer);
                // isDoc && (newMessages[newMessages.length - 1].isDoc = isDoc);
                isRAG && (newMessages[newMessages.length - 1].isRAG = isRAG);
                threadId && (newMessages[newMessages.length - 1].threadId = threadId);
                // docId && (newMessages[newMessages.length - 1].docId = docId);
                replyId && (newMessages[newMessages.length - 1].replyId = replyId);
                docId && (newMessages[newMessages.length - 1].docId = docId);
                appId && (newMessages[newMessages.length - 1].appId = appId);
                scrapId && (newMessages[newMessages.length - 1].scrapId = scrapId);
              } else {
                newMessages.push({
                  text: accumulatedText,
                  type: "bot",
                  ...(timestamp && { timestamp: timestamp }),
                  ...(isRecord && { isAudio: isRecord }),
                  ...(isGraph && { isGraph: isGraph }),
                  ...(isApi && { isApi: isApi }),
                  ...(isAction && { isAction: isAction }),
                  ...(isTable && { isTable: isTable }),
                  ...(isAutomate && { isAutomate: isAutomate }),
                  ...(isAsset && { isAsset: isAsset }),
                  ...(isImage && { isImage: isImage }),
                  ...(isAudio && { isAudio: isAudio }),
                  ...(isOnline && { isOnline: isOnline }),
                  ...(isViewer && { isViewer: isViewer }),
                  // ...(isDoc && { isDoc: isDoc }),
                  ...(isRAG && { isRAG: isRAG }),
                  ...(threadId && { threadId: threadId }),
                  ...(docId && { docId: docId }),
                  ...(appId && { appId: appId }),
                  ...(scrapId && { scrapId: scrapId }),
                  ...(replyId && { replyId: replyId }),
                });
              }
              return newMessages;
            });
          }



          const processStream = async () => {
            while (true) {
              // Verificar si está pausado antes de leer
              if (isPausedRef.current) {
                await new Promise(resolve => setTimeout(resolve, 100));
                continue;
              }

              const { done, value } = await readerMessageRef.current.read();
              if (done) {
                setFinishedResponseBot(true)
                setIsLoadBot(false);
                dispatch(fetchByMenu({ query: searchTermState }));
                dispatch(getAgents({ token }));
                console.log('buscando chat')
                break;
              }

              const chunk = decoder.decode(value, { stream: true });

              accumulatedChunks += chunk;

              let lines = accumulatedChunks.split("\n");
              accumulatedChunks = lines.pop();

              for (const line of lines) {
                if (line.trim()) {
                  try {
                    const chunk = JSON.parse(line);
                    const { text, type, threadId, docId, appId, streamId, timestamp } = chunk.data;
                    setTokenOutput((prev) => Number(prev || 0) + Number(chunk?.data?.output.token));

                    console.log("chunk", text)
                    console.log("threadId", threadId)
                    console.log("docId", docId)
                    console.log("appId", appId)
                    console.log("streamId", streamId)
                    console.log("type", type)

                    setShowInfoMessage(true)

                    const firstBackendResponseTime = Date.now();
                    const timeDiffMs = firstBackendResponseTime - startTime;

                    setTimeToFinishResponse(timeDiffMs);

                    if (type === "graph") {
                      let mermaidCode = '';

                      const corporateColors = {
                        primary: 'green',
                        secondary: 'teal',
                        accent: 'darkgreen',
                        light: 'lightgreen',
                        dark: 'darkgreen',
                        neutral: 'grey'
                      };

                      switch (text.style) {
                        case 'pie':
                          mermaidCode = `pie
                                  title "${text.data.title || "Distribución"}"
                                  ${text.data.slices
                              .map(slice => `"${slice.label}" : ${slice.value}`)
                              .join("\n")}`;
                          break;

                        case 'bar':
                          mermaidCode = `xychart-beta
                                  title "${text.data.title || "Valores"}"
                                  x-axis [${text.data.bars.map(bar => `"${bar.label}"`).join(", ")}]
                                  y-axis "Valores" 0 --> ${Math.max(...text.data.bars.map(bar => bar.value))}
                                  bar [${text.data.bars.map(bar => bar.value).join(", ")}]`;
                          break;

                        case 'flow':
                          mermaidCode = `flowchart TD
                                  ${text.data.nodes
                              .map(node => `${node.id}["${node.label}"]`)
                              .join("\n")}
                                  ${text.data.edges
                              .map(edge => `${edge.from} --> ${edge.to}`)
                              .join("\n")}`;
                          break;

                        case 'sequence':
                          mermaidCode = `sequenceDiagram
                                  participant A as "${text.data.participants[0]}"
                                  participant B as "${text.data.participants[1]}"
                                  ${text.data.messages
                              .map(msg => `${msg.from}->>+${msg.to}: ${msg.text}`)
                              .join("\n")}`;
                          break;

                        default:
                          mermaidCode = `pie
                                  title "Sin datos"
                                  "Sin datos" : 100`;
                      }

                      const graphId = `mermaid-${Date.now()}`;

                      try {
                        const { svg } = await mermaid.render(
                          graphId,
                          mermaidCode
                        );

                        insertMessage({
                          text: `<div class="${styles.mermaidGraph}">${svg}</div>`,
                          isGraph: true,
                          threadId,
                          timestamp,
                        });
                      } catch (mermaidError) {
                        console.error(
                          "Error renderizando gráfico:",
                          mermaidError
                        );
                        insertMessage({
                          text: `Error en el gráfico`,
                          threadId,
                          timestamp,
                        });
                      }
                    } else if (type == "table") {
                      console.log('table', text)
                      insertMessage({ text, isTable: true, threadId, timestamp });
                    } else if (type === "automate") {
                      insertMessage({ text, isAutomate: true, threadId, timestamp });
                    } else if (type === "api") {
                      console.log('is api consulta nueva en axios para que funcione lo nuevo ver donde se ejcuta')
                      insertMessage({ text, isApi: true, threadId, timestamp, url: text.url });
                    } else if (type == "voice") {
                      insertMessage({ text, isVoice: true, threadId, timestamp });
                      const texto = new SpeechSynthesisUtterance(text);
                      texto.lang = "es-ES";
                      window.speechSynthesis.speak(texto);
                    } else if (type == "action") {
                      insertMessage({ text, isAction: true, threadId, timestamp });
                    } else if (type == "pause") {
                      setMessages((prevMessages) => {
                        const newMessages = [...prevMessages];
                        newMessages.push({ text: "parar el mensaje", type: "pause" });
                        return newMessages;
                      });
                    } else if (type == "image") {
                      insertMessage({ text, isImage: true, threadId, timestamp });
                    } else if (type == "audio") {
                      insertMessage({ text, isAudio: true, threadId, timestamp });
                    } else if (type == "online") {
                      insertMessage({ text, isOnline: true, threadId, timestamp });
                    } else if (type == "asset") {
                      insertMessage({ text, isAsset: true, threadId, timestamp });
                    } else if (type == "viewer") {
                      insertMessage({ text, isViewer: true, threadId, timestamp });
                    } else if (type == "doc") {
                      // Activar el componente MessageDoc con el contenido del documento
                      // console.log('doccccccc', text)
                      let html = ''
                      if (text.status == 200) {
                        html = text.html
                        text.isAutomate = false

                      } else if (text.status == 201) {
                        const updateMessages = messages.map(message => {
                          if (message.timestamp !== text.timestamp) {
                            return message
                          }
                        }).filter(Boolean)
                        setMessages(updateMessages)
                      } else if (text.status == 202) {
                        const updateMessages = messages.map(message => {
                          if (message.timestamp !== text.timestamp) {
                            return message
                          }
                        }).filter(Boolean)
                        setMessages(updateMessages)
                      }


                      // dispatch(setMessageDocsShow(true));
                      // dispatch(setMessageDocsData(html));
                      insertMessage({ text, docId: text.id, timestamp });
                    } else if (type == "app") {

                      console.log('type app', text)
                      console.log('type app', appId)
                      insertMessage({ text, appId, timestamp });
                    } else if (type == "fn") {
                      if (text && text.status == 500) { // cancelApiScraping  
                        const updateMessages = messages.map(message => {
                          if (message.timestamp === text.timestamp) {
                            return {
                              ...message,
                              text: {
                                ...message.text,
                                status: 500
                              }
                            }
                          }
                          return message
                        }).filter(Boolean)
                        setMessages(updateMessages)
                      } else if (text && text.status == 201) { // createApiScraping
                        const updateMessages = messages.map(message => {
                          if (message.timestamp !== text.timestamp) {
                            return message
                          }
                        }).filter(Boolean)
                        setMessages(updateMessages)
                      } else if (text && text.status == 202) { // createTableFromApi
                        const updateMessages = messages.map(message => {
                          if (message.timestamp !== text.timestamp) {
                            return message
                          }
                        }).filter(Boolean)
                        setMessages(updateMessages)
                      }
                    } else if (type == "scraping") {
                      insertMessage({ text, scrapId, timestamp });
                    } else {
                      insertMessage({ text, threadId, docId, appId, timestamp });
                    }
                  } catch (error) {
                    console.error("Failed to parse JSON:", error);
                  }
                }
              }
            }
          };
          
          processStream()
          .then(() => { })
          .catch(console.error);
     
        }

      })
    } catch (error) {
      console.error("Error sending message:", error);
      setIsLoadBot(false);
    }
  };


  const handleChat = (action) => {
    // setIsLoadBot(true);
    if (action.id == 0) {
      navigate(`/admin/agent`, { state: { backgroundLocation: location } });
      setUserData({
        Capabilities: [
          {
            webSearch: false,
            dallEImageGeneration: false,
            facturaGPTCodeInterpretor: false,
          },
        ],
        pinned: false,
        tone: 3,
        answer: 3,
      });
      const new_id = uuidv4();
      setChatAgentId(new_id);
      setIdSelectedAgent(null);
    } else if (action.id == 1) {
      navigate(`/admin/home`);
    } else if (action.id == 3 || action.id == 4 || action.id == 5) {
      handleSendMessage({
        text: action.message,
        agentName: selectedAgent?.name
      });
    } else if (action.id == 5) {
    } else if (action.id == 6) {
      navigate(`/contact`);
    } else if (action.id !== 0) {
      handleSendMessage({
        text: action.text,
        agentName: selectedAgent?.name,
        agentId: selectedAgent?._id,
        file: action.file
      });
    }

    // Añadir manejo de mensajes de scraping
    if (action.type === 'scraping_execute') {
      // El backend manejará la ejecución del scraping
      // Aquí solo enviamos el mensaje normal
      const messageData = {
        text: action.text,
        agent: action.agent || selectedAgent?.name,
        agentId: action.agentId || selectedAgent?._id,
        file: filePayload,
        scrapingTemplate: action.template // Añadir el template al mensaje
      };
      
      // Continuar con el flujo normal...
    }
  };

  const handleMouseDown = (e) => {
    isResizing.current = true;
    startX.current = e.clientX;
    document.body.style.cursor = "ew-resize";
    document.body.style.userSelect = "none";
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const handleMouseMove = (e) => {
    if (!isResizing.current) return;

    const offset = e.clientX - startX.current;
    const newWidth = leftWidth + (offset / window.innerWidth) * 2000;

    if (newWidth > 200 && newWidth < 700) {
      setLeftWidth(newWidth);
    }
  };

  const handleMouseUp = () => {
    isResizing.current = false;
    document.body.style.cursor = "auto";
    document.body.style.userSelect = "auto";
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
  };

  const toggleMenu = () => {
    setMenuOpenChat(!menuOpenChat);
  };



  useEffect(() => {
    if (inputValue.includes("@")) {
      const countArroba = (text) => text.split('@').length - 1;
      const currentCount = countArroba(inputValue)
      if (currentCount < arrobaCount) {
        setSelectItemCount(selectItemCount - 1)
        setArrobaCount(arrobaCount)
        let newItemsSelected = [...itemsSelected]
        newItemsSelected = newItemsSelected.slice(0, -1)
        setItemsSelected([...newItemsSelected])
      }
      setArrobaCount(currentCount)
      if (currentCount > selectItemCount) {
        setContainsArroba(true)
      } else setContainsArroba(false)
    } else {
      setSelectItemCount(0)
      setItemsSelected([])
      setContainsArroba(false)
    }

    // Si el input está vacío, permitir navegación por memoria
    // if (inputValue === '') {
    //   setIsNavigatingHistory(false);
    // }
  }, [inputValue])

  // useEffect(() => {
  //   dispatch(
  //     getAgentById({
  //       idSelectedAgent: agentId,
  //       setUserData: setSelectedAgent,
  //       setlanguage,
  //     })
  //   );
  // }, [agentId]);

  useEffect(() => {
    if (emptyChat) {
      if (chatId == emptyChat || emptyChat == "all") setMessages([])
      dispatch(setEmptyChat(false))
    }
  }, [emptyChat])


  useEffect(() => {
      setMessages(currentChat.messages);
  }, [currentChat]);

  useEffect(() => {
    const uuidV4Regex =
      /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

    if (chatId) {
      dispatch(fetchByChat({ chatId: chatId }));
    }
  }, [chatId, dispatch]);

  useEffect(() => {

    setAutoClear(currentChat?.autoClear)

  }, [currentChat])

  useEffect(() => {

    setSearchInWeb(currentChat?.searchInWeb)

  }, [currentChat?.searchInWeb])

  useEffect(() => {
    setTokenInput(0)
    setTokenOutput(0)
    setTimeToFinishResponse(0)
  }, [chatId])



  useEffect(() => {
    console.log('134543451111qqqq', question, location?.state?.typeAutomate)

    // if(question && location?.state?.typeAutomate && location?.state?.selectedAgentState){
    if (question && location?.state?.typeAutomate) {

      setMessages(prev => [
        ...prev,
        {
          type: 'bot',
          text: Google['help-automate'],
        }
      ])
    }
  }, [location.state, question]);

  // Efecto para manejar mensaje inicial desde FolderIndicator
  useEffect(() => {
    if (location?.state?.initialMessage && selectedAgent?._id) {
      console.log('🚀 Enviando mensaje inicial desde FolderIndicator:', location.state.initialMessage);

      // Enviar el mensaje inicial automáticamente
      handleSendMessage({
        text: location.state.initialMessage,
        agentName: selectedAgent?.name,
        agentId: selectedAgent?._id,
        newChat: true
      });

      // Limpiar el estado para evitar reenvíos
      navigate(location.pathname, { replace: true });
    }
  }, [location?.state?.initialMessage, selectedAgent?._id]);


  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    dispatch(getTokens({ id: user?.id?.split("_").pop() }))
  }, [])


  return (
    <div className={styles.chatSection}>

      <ChatBody
        itemsSelected={itemsSelected}
        setItemsSelected={setItemsSelected}
        handleSendMessage={handleSendMessage}
        // stateAutomate={stateAutomate} 
        // setStateAutomate={setStateAutomate}
        user={user}
        tokens={tokens}
        isLoadBot={isLoadBot}
        windowWidth={windowWidth}
        showReply={showReply}
        setShowReply={setShowReply}
        handleChat={handleChat}
        messages={messages}
        setMessages={setMessages}
        inputValue={inputValue}
        setInputValue={setInputValue}
        // setShowNewAgent={setShowNewAgent}
        // setUserData={setUserData}
        setIdSelectedAgent={setIdSelectedAgent}
        // setSelectedAgent={setSelectedAgent}
        selectedAgent={selectedAgent}
        userData={userData}
        // setChatAgentId={setChatAgentId}
        chatId={chatId}
        autoClear={autoClear}
        setAutoClear={setAutoClear}
        tokenInput={tokenInput}
        tokenOutput={tokenOutput}
        timeToFinishResponse={timeToFinishResponse}
        finishedResponseBot={finishedResponseBot}
        setTokenInput={setTokenInput}
        setTokenOutput={setTokenOutput}
        setTimeToFinishResponse={setTimeToFinishResponse}
        showInfoMessage={showInfoMessage}
        setShowInfoMessage={setShowInfoMessage}
        newChat={newChat}
        searchInWeb={searchInWeb}
        setSearchInWeb={setSearchInWeb}
        setNewChat={setNewChat}
        filePayload={filePayload} setFilePayload={setFilePayload}
        setContainsArroba={setContainsArroba}
        containsArroba={containsArroba}
        handleSelectItem={handleSelectItem}
        agentId={agentId}
        currentChat={currentChat}
        setIsPaused={setIsPaused}
        isPaused={isPaused}
        apiUrl={apiUrl}
      />
      {showNewAgent && (
        <NewAgentComponent
          setShowNewAgent={setShowNewAgent}
          // idSelectedAgent={idSelectedAgent}
          setUserData={setUserData}
          userData={userData}
          chatAgentId={chatAgentId}
        // setSelectedAgent={setSelectedAgent}
        />
      )}

      {showCorporativeModal && (
        <SelectAgentModal
          setState={setShowCorporativeModal}
        // setSelectedAgent={setSelectedAgent}
        // selectedAgent={selectedAgent}
        // userData={userData}
        // setChatAgentId={setChatAgentId}
        // chatId={chatId}
        // autoClear={autoClear}
        // setAutoClear={setAutoClear}
        // setSearchInWeb={setSearchInWeb}
        // searchInWeb={searchInWeb}
        // currentChat={currentChat}
        // tokenInput={tokenInput}
        // tokenOutput={tokenOutput}
        // timeToFinishResponse={timeToFinishResponse}
        // newChat={newChat}
        // setNewChat={setNewChat}
        // filePayload={filePayload} setFilePayload={setFilePayload}
        // setContainsArroba={setContainsArroba}
        // containsArroba={containsArroba}
        // handleSelectItem={handleSelectItem}
        // setTokenInput={setTokenInput}
        // setTokenOutput={setTokenOutput}
        // setTimeToFinishResponse={setTimeToFinishResponse}
        />
      )}

    </div>
  );
};

export default ChatView;





const HighlightedText = ({ text, annotations }) => {
  const [hoveredAnnotation, setHoveredAnnotation] = useState(null);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  const handleMouseEnter = (annotation, event) => {
    setHoveredAnnotation(annotation);
    setMousePosition({ x: event.clientX, y: event.clientY });
  };

  const handleClick = (annotation) => {
    window.open(annotation.url_citation.url, '_blank');
  };

  if (!text || !annotations || annotations.length === 0) {
    return <div className={styles.highlightedTextContainer}>{text}</div>;
  }


  const sortedAnnotations = [...annotations].sort((a, b) => a.start_index - b.start_index);

  let result = [];
  let lastIndex = 0;

  sortedAnnotations.forEach((annotation, i) => {
    const start = annotation.url_citation.start_index;
    const end = annotation.url_citation.end_index;
    if (start > lastIndex) {
      const fragment = text.substring(lastIndex, start);
      result.push(
        <span
          key={`highlight-${i}`}
          className={styles.highlightedCitation}
          onMouseEnter={(e) => handleMouseEnter(annotation, e)}
          onMouseLeave={() => setHoveredAnnotation(null)}
          onClick={() => handleClick(annotation)}
        >
          {fragment}
        </span>
      );
    }
    lastIndex = end;
  });

  if (lastIndex < text.length) {
    result.push(text.substring(lastIndex));
  }

  return (
    <p className={styles.highlightedTextContainer}>
      {result}
      {hoveredAnnotation && (
        <div
          className={styles.citationPopup}
          style={{
            position: 'fixed',
            left: `${mousePosition.x + 10}px`,
            top: `${mousePosition.y + 10}px`,
            zIndex: 1000
          }}
        >
          <b>{hoveredAnnotation.url_citation.title}</b>
          <a href={hoveredAnnotation.url_citation.url} target="_blank" rel="noopener noreferrer">
            {hoveredAnnotation.url_citation.url}
          </a>
        </div>
      )}
    </p>
  );
};


const VoiceRecorderWave = forwardRef(({ onSend, onCancel }, ref) => {
  const [recording, setRecording] = useState(false);
  const [audioUrl, setAudioUrl] = useState(null);
  const [audioBlob, setAudioBlob] = useState(null);
  const [samples, setSamples] = useState([]);
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const [audioChunks, setAudioChunks] = useState([]);
  const [playing, setPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const audioRef = useRef(null);
  const analyserRef = useRef(null);
  const dataArrayRef = useRef([]);
  const animationRef = useRef(null);
  const [visualSamples, setVisualSamples] = useState([]);
  const [recordingTime, setRecordingTime] = useState(0);
  const [hoverBar, setHoverBar] = useState(null);
  const recordingRef = useRef(recording);
  const playingRef = useRef(playing);
  const audioUrlRef = useRef(audioUrl);


  const startRecording = async () => {
    setSamples([]);
    setVisualSamples([]);
    setAudioUrl(null);
    setAudioBlob(null);
    setAudioChunks([]);
    setCurrentTime(0);
    setDuration(0);
    setPlaying(false);
    setRecordingTime(0);
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mediaRecorder = new window.MediaRecorder(stream);
      setMediaRecorder(mediaRecorder);
      let localChunks = [];
      mediaRecorder.ondataavailable = (e) => {
        if (e.data.size > 0) localChunks.push(e.data);
      };
      mediaRecorder.onstop = () => {
        const blob = new Blob(localChunks, { type: "audio/webm" });
        setAudioBlob(blob);
        setAudioUrl(URL.createObjectURL(blob));
        setDuration(blob.duration);
      };

      const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
      const source = audioCtx.createMediaStreamSource(stream);
      const analyser = audioCtx.createAnalyser();
      analyser.fftSize = 2048;
      source.connect(analyser);
      analyserRef.current = analyser;
      dataArrayRef.current = new Uint8Array(analyser.frequencyBinCount);
      let lastSampleTime = 0;
      let tempSamples = [];
      let tempMax = 0;
      let startTimestamp = Date.now();

      const capture = () => {
        analyser.getByteTimeDomainData(dataArrayRef.current);

        const max = Math.max(...dataArrayRef.current.map(v => Math.abs(v - 128)));

        const scaled = Math.min(1, max / 64);
        tempMax = Math.max(tempMax, scaled);
        const now = Date.now();
        if (now - lastSampleTime >= 250) {
          tempSamples.push(tempMax);
          setVisualSamples([...tempSamples]);
          tempMax = 0;
          lastSampleTime = now;
        }
        if (mediaRecorder.state === "recording") {
          setRecordingTime(((now - startTimestamp) / 1000));
          animationRef.current = requestAnimationFrame(capture);
        } else {
          setSamples([...tempSamples]);
        }
      };
      mediaRecorder.onstart = () => {
        setRecording(true);
        animationRef.current = requestAnimationFrame(capture);
      };
      mediaRecorder.onstop = () => {
        setRecording(false);
        cancelAnimationFrame(animationRef.current);
        setSamples([...tempSamples]);
        setVisualSamples([...tempSamples]);
        stream.getTracks().forEach((track) => track.stop());
        const blob = new Blob(localChunks, { type: "audio/webm" });
        setAudioBlob(blob);
        setAudioUrl(URL.createObjectURL(blob));
      };
      mediaRecorder.start();
    } catch (err) {
      alert("No se pudo acceder al micrófono");
      setRecording(false);
    }
  };


  const stopRecording = () => {
    if (mediaRecorder && mediaRecorder.state === "recording") {
      mediaRecorder.stop();
    }
  };


  const handleCancel = () => {
    setAudioUrl(null);
    setAudioBlob(null);
    setSamples([]);
    setVisualSamples([]);
    setAudioChunks([]);
    setRecording(false);
    setPlaying(false);
    setCurrentTime(0);
    setDuration(0);
    if (onCancel) onCancel();
  };


  const handlePlay = () => {
    if (!audioUrl) return;
    setPlaying(true);
    if (audioRef.current) {
      audioRef.current.currentTime = 0;
      audioRef.current.play();
    }
  };
  const handlePause = () => {
    setPlaying(false);
    if (audioRef.current) {
      audioRef.current.pause();
    }
  };

  useEffect(() => {
    if (!audioRef.current) return;
    const audio = audioRef.current;
    const onEnded = () => {
      setPlaying(false);
      setCurrentTime(0);
    };
    const onTimeUpdate = () => {
      setCurrentTime(audio.currentTime);
    };
    const onLoadedMetadata = () => {

      if (!isFinite(audio.duration) || audio.duration === 0) {
        const fixDuration = () => {
          if (isFinite(audio.duration) && audio.duration > 0) {
            setDuration(audio.duration);
            audio.removeEventListener('timeupdate', fixDuration);
            audio.currentTime = 0;
          }
        };
        audio.addEventListener('timeupdate', fixDuration);
        audio.currentTime = 1e101;
      } else {
        setDuration(audio.duration);
      }
    };
    audio.addEventListener("ended", onEnded);
    audio.addEventListener("timeupdate", onTimeUpdate);
    audio.addEventListener("loadedmetadata", onLoadedMetadata);
    return () => {
      audio.removeEventListener("ended", onEnded);
      audio.removeEventListener("timeupdate", onTimeUpdate);
      audio.removeEventListener("loadedmetadata", onLoadedMetadata);
    };
  }, [audioUrl]);


  const bars = audioUrl ? samples : visualSamples;

  let currentBar = 0;
  if (audioUrl && duration > 0 && bars.length > 0) {
    currentBar = Math.floor((currentTime / duration) * bars.length);
    if (currentBar < 0) currentBar = 0;
    if (currentBar > bars.length - 1) currentBar = bars.length - 1;
  }


  useEffect(() => {
    let raf;
    if (playing) {
      const update = () => {
        setCurrentTime(audioRef.current.currentTime);
        raf = requestAnimationFrame(update);
      };
      raf = requestAnimationFrame(update);
    }
    return () => raf && cancelAnimationFrame(raf);
  }, [playing]);


  const handleBarClick = (i) => {
    if (!audioRef.current || !duration || !audioUrl) return;
    const newTime = (i / bars.length) * duration;
    audioRef.current.currentTime = newTime;
    setCurrentTime(newTime);

    if (!playing) {
      setTimeout(() => setCurrentTime(audioRef.current.currentTime), 10);
    } else {
      setPlaying(true);
      audioRef.current.play();
    }
  };


  const formatTime = (s) => {
    if (!isFinite(s) || isNaN(s) || s < 0) return "00:00";
    const m = Math.floor(s / 60);
    const sec = Math.floor(s % 60);
    return `${m.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;
  };

  useEffect(() => {
    startRecording()
  }, [])
  const audioBlobRef = useRef(null);
  const samplesRef = useRef([]);

  const audioBlobReadyRef = useRef(null);

  useEffect(() => {
    if (audioBlob && audioBlobReadyRef.current) {
      audioBlobReadyRef.current(audioBlob);
      audioBlobReadyRef.current = null;
    }
  }, [audioBlob]);
  useEffect(() => {
    audioBlobRef.current = audioBlob;
    samplesRef.current = samples;
  }, [audioBlob, samples]);


  useEffect(() => {
    recordingRef.current = recording;
  }, [recording]);

  useEffect(() => {
    playingRef.current = playing;
  }, [playing]);

  useEffect(() => {
    audioUrlRef.current = audioUrl;
  }, [audioUrl]);

  useImperativeHandle(ref, () => ({
    startRecording,
    stopRecording,
    handlePlay,
    handlePause,
    handleCancel,
    sendRecording: async () => {

      if (audioBlobRef.current) {
        onSend && onSend({ audioBlob: audioBlobRef.current, samples: samplesRef.current });
        return;
      }


      await new Promise((resolve) => {
        audioBlobReadyRef.current = resolve;
      });

      onSend && onSend({ audioBlob: audioBlobRef.current, samples: samplesRef.current });
    },

    isRecording: () => recordingRef.current,
    isPlaying: () => playingRef.current,
    hasAudio: () => !!audioUrlRef.current,
  }));
  return (
    <div className={styles.chatRecorder}>
      <div className={styles.chatRecorderPlay}>

        <audio ref={audioRef} src={audioUrl || undefined} style={{ display: "none" }} />
      </div>
      <div className={styles.chatRecorderBars}>
        {bars.map((amp, i) => {
          let color = "#bbb";
          if (audioUrl && duration > 0 && i <= currentBar) color = "rgb(16 163 127)";
          if (hoverBar === i) color = "#81c784";
          return (
            <div
              key={i}
              style={{
                width: 6,
                height: Math.max(amp * 40, 4),
                background: color,
                borderRadius: 2,
                transition: "background 0.1s, height 0.1s",
              }}
              onClick={() => handleBarClick(i)}
              onMouseEnter={() => setHoverBar(i)}
              onMouseLeave={() => setHoverBar(null)}
            />
          );
        })}
      </div>
      <div className={styles.chatRecorderBarsBar}>
        {recording && !audioUrl && (
          <span>{formatTime(recordingTime)}</span>
        )}
        {audioUrl && (
          <span style={{ marginLeft: 8 }}>
            {formatTime(currentTime)} / {formatTime(isFinite(duration) && !isNaN(duration) && duration > 0 ? duration : (audioRef.current && !isNaN(audioRef.current.duration) && isFinite(audioRef.current.duration) && audioRef.current.duration > 0 ? audioRef.current.duration : 0))}
          </span>
        )}
      </div>
    </div>
  );
});


const VoiceMessageBubble = ({ audioBlob, samples }) => {



  const [playing, setPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [hoverBar, setHoverBar] = useState(null);
  const [audioUrl, setAudioUrl] = useState(null);
  const audioRef = useRef(null);

  useEffect(() => {
    if (!audioRef.current) return;
    const audio = audioRef.current;
    const onEnded = () => {
      setPlaying(false);
      setCurrentTime(0);
    };
    const onTimeUpdate = () => {
      setCurrentTime(audio.currentTime);
    };
    const onLoadedMetadata = () => {

      if (!isFinite(audio.duration) || audio.duration === 0) {
        const fixDuration = () => {
          if (isFinite(audio.duration) && audio.duration > 0) {
            setDuration(audio.duration);
            audio.removeEventListener('timeupdate', fixDuration);
            audio.currentTime = 0;
          }
        };
        audio.addEventListener('timeupdate', fixDuration);
        audio.currentTime = 1e101;
      } else {
        setDuration(audio.duration);
      }
    };
    audio.addEventListener("ended", onEnded);
    audio.addEventListener("timeupdate", onTimeUpdate);
    audio.addEventListener("loadedmetadata", onLoadedMetadata);
    return () => {
      audio.removeEventListener("ended", onEnded);
      audio.removeEventListener("timeupdate", onTimeUpdate);
      audio.removeEventListener("loadedmetadata", onLoadedMetadata);
    };
  }, [audioBlob]);


  useEffect(() => {
    let raf;
    if (playing) {
      const update = () => {
        setCurrentTime(audioRef.current.currentTime);
        raf = requestAnimationFrame(update);
      };
      raf = requestAnimationFrame(update);
    }
    return () => raf && cancelAnimationFrame(raf);
  }, [playing]);


  const createBlobFromBase64 = (base64String) => {
    try {

      if (!base64String || typeof base64String !== 'string') {
        console.error('Invalid base64 string:', base64String);
        return null;
      }


      const cleanBase64 = base64String.replace(/^data:audio\/[^;]+;base64,/, '');


      if (!/^[A-Za-z0-9+/]*={0,2}$/.test(cleanBase64)) {
        console.error('Invalid base64 format');
        return null;
      }


      const byteCharacters = atob(cleanBase64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);


      return new Blob([byteArray], { type: 'audio/webm' });
    } catch (error) {
      console.error('Error converting base64 to Blob:', error);
      return null;
    }
  };

  // Create blob and URL when component mounts or audioBlob changes
  useEffect(() => {
    if (!audioBlob || !samples || !Array.isArray(samples) || samples.length === 0) {
      return;
    }

    const blob = createBlobFromBase64(audioBlob);
    if (blob) {
      const url = URL.createObjectURL(blob);
      setAudioUrl(url);

      // Cleanup function to revoke the URL when component unmounts
      return () => {
        if (url) {
          URL.revokeObjectURL(url);
        }
      };
    }
  }, [audioBlob, samples]);

  if (!audioBlob || !samples || !Array.isArray(samples) || samples.length === 0) {
    return (
      <div style={{ padding: 16, color: '#888', fontStyle: 'italic', background: '#f8f8f8', borderRadius: 8, margin: '12px 0' }}>
        No hay audio para reproducir o los datos de la onda no están disponibles.
      </div>
    );
  }

  if (!audioUrl) {
    return (
      <div style={{ padding: 16, color: '#ff6b6b', fontStyle: 'italic', background: '#fff5f5', borderRadius: 8, margin: '12px 0' }}>
        Error: No se pudo procesar el audio. Verifica que los datos sean válidos.
      </div>
    );
  }




  const handlePlay = () => {
    setPlaying(true);
    audioRef.current.currentTime = 0;
    audioRef.current.play();
  };
  const handlePause = () => {
    setPlaying(false);
    audioRef.current.pause();
  };


  const formatTime = (s) => {
    const m = Math.floor(s / 60);
    const sec = Math.floor(s % 60);
    return `${m.toString().padStart(1, '0')}:${sec.toString().padStart(2, '0')}`;
  };


  let currentBar = 0;
  if (duration > 0 && samples.length > 0) {
    currentBar = Math.floor((currentTime / duration) * samples.length);
    if (currentBar < 0) currentBar = 0;
    if (currentBar > samples.length - 1) currentBar = samples.length - 1;
  }


  const handleBarClick = (i) => {
    if (!audioRef.current || !duration || !samples.length) return;
    const newTime = (i / samples.length) * duration;
    audioRef.current.currentTime = newTime;
    setCurrentTime(newTime);
    if (!playing) {
      setTimeout(() => setCurrentTime(audioRef.current.currentTime), 10);
    } else {
      setPlaying(true);
      audioRef.current.play();
    }
  };

  return (
    <div className={styles.voiceMessageBubble} >
      <div className={styles.voiceMessageBubbleTime}>

        {playing ? (
          <button
            onClick={handlePause}
            title="Pausar"
            className={styles.voiceMessageBubbleButton}
          // style={{ background: 'none', border: 'none', outline: 'none', cursor: 'pointer' }}
          >
            ⏸️
          </button>
        ) : (
          <button
            onClick={handlePlay}
            title="Reproducir"
            className={styles.voiceMessageBubbleButton}
          // style={{ background: 'none', border: 'none', outline: 'none', cursor: 'pointer' }}
          >
            ▶️
          </button>
        )}
        <span>
          {formatTime(currentTime)} / {formatTime(duration)}
        </span>
      </div>
      <div style={{ display: "flex", alignItems: "flex-end", height: 32, gap: 2, cursor: 'pointer', userSelect: 'none' }}>
        {samples.map((amp, i) => {
          let color = "#bbb";
          if (i <= currentBar) color = "var(--_16c098-background)";
          if (hoverBar === i) color = "var(--f5_secondary)";
          return (
            <div
              key={i}
              style={{
                width: 4,
                height: Math.max(amp * 32, 4),
                background: color,
                borderRadius: 2,
                transition: "background 0.1s, height 0.1s",
              }}
              onClick={() => handleBarClick(i)}
              onMouseEnter={() => setHoverBar(i)}
              onMouseLeave={() => setHoverBar(null)}
            />
          );
        })}
      </div>

      <audio ref={audioRef} src={audioUrl || undefined} style={{ display: "none" }} />
    </div>
  );
};



const ViewerContainer = ({ message }) => {
  const navigate = useNavigate()

  const data = message.text?.data || {}
  const type = message.text?.type || null

  const items = [
    {
      label: 'Categoría',
      value: 'Categoría'
    },
  ]

  const Tags = ({ items }) => {
    return (
      <div className={styles.viewerContainerTags}>
        {items.map((item, index) => (
          <div
            key={index}
            className={styles.viewerContainerTagsItem}
          >
            {item.label}

            <IconDelete />
          </div>
        ))}
      </div>
    )
  }


  const [title, setTitle] = useState("")

  useEffect(() => {
    let text = ""
    if (type === 'docs') {
      text = "Buscar un nuevo documento"
    } else if (type === 'assets') {
      text = "Buscar un nuevo activo"
    } else if (type === 'contacts') {
      text = "Buscar un nuevo contacto"
    } else if (type === 'agents') {
      text = "Buscar un nuevo agente"
    }

    setTitle(text)
  }, [type])

  const [viewMore, setViewMore] = useState(false)

  const onViewMore = () => {
    setViewMore(!viewMore)
  }

  const onClick = () => {
    if (type === 'docs') {
      navigate(`/admin/docs/${data._id}`)
    } else if (type === 'assets') {
      navigate(`/admin/assets/${data._id}`)
    } else if (type === 'contacts') {
      navigate(`/admin/contacts/${data._id}`)
    } else if (type === 'agents') {
      navigate(`/admin/agents/${data._id}`)
    }
  }

  return (
    <div className={styles.viewerSection}>
      <div className={styles.viewerContainerSearch}>
        <p>
          {title}
        </p>
        <div>
          <IconSearch />
          <input type="text" placeholder={title} />
        </div>
      </div>
      {type === 'docs' ? (
        <div className={styles.viewerContainer} onClick={onClick}>
          <div className={styles.viewerContainerHeader}>
            <div className={styles.viewerContainerAvatar}>
              ABC
            </div>
            <div className={styles.viewerContainerInfo}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10 }}>
                <b>
                  {data.title || 'Titulo del documento'}
                </b>
                <div className={styles.viewerContainerStatus}>
                  {true ? (
                    <label>
                      aceptado
                    </label>
                  ) : (
                    <label>

                      no aceptado
                    </label>
                  )}
                </div>

              </div>
              <div className={styles.viewerContainerStats}>
                <label>
                  999kb
                </label>
                <label>
                  Categoría
                </label>
                <label>
                  Concepto
                </label>
              </div>
              <span style={{ display: 'block' }}>/location</span>
              <Tags items={items} />
              <div className={styles.viewerContainerButtons}>
                <button>
                  <IconView />
                  Ver
                </button>
                <button className={styles.active}>
                  <IconLock />
                  Aprobar
                </button>
                <button>
                  <div className={styles.viewerContainerButtonsDot} />
                  Pagado
                </button>

              </div>
            </div>
          </div>
          <div className={styles.viewerContainerActions}>
            {viewMore && (
              <div>
                <button>
                  <IconSend />
                </button>
                <button>
                  <IconTag />
                </button>
                <button>
                  <IconEmail />
                </button>
              </div>
            )}
            {viewMore && (
              <>
                <button>
                  <IconPrint />
                </button>
                <button>
                  <IconCopy />
                </button>
                <button>
                  <IconDownload />
                </button>
                <button>
                  <IconShare />
                </button>
                <button>
                  <IconAutomate />
                </button>
              </>
            )}
            <button className={styles.second}>
              <IconEdit />
            </button>
            <button
              className={styles.second}
              onClick={onViewMore}
            >
              <IconPlus />
            </button>
          </div>
        </div>
      ) : type === 'assets' ? (
        <div className={styles.viewerContainer} onClick={onClick}>
          <div className={styles.viewerContainerHeader}>
            <div className={styles.viewerContainerAvatar}>

            </div>
            <div className={styles.viewerContainerInfo}>
              <b>
                {data.title || 'Nombre del activo'}
              </b>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <span>
                  {data.text || 'Tipo de activo'}
                </span>
                <span>
                  {data.text || 'Tipo de categoria'}
                </span>
                <span>
                  {data.text || 'Código'}
                </span>
              </div>
              <span>
                {data.id || 'Descripción'}
              </span>
              <div className={styles.viewerContainerButtons}>
                <button>
                  <IconView />
                  Ver
                </button>
                <Tags items={items} />
              </div>
            </div>
          </div>
          <div className={styles.viewerContainerActions}>
            <button>
              <IconAttach />
            </button>
            <button>
              <IconTag />
            </button>
            <button>
              <IconLocation />
            </button>
            <button className={styles.second}>
              <IconEdit />
            </button>
            <button className={styles.second}>
              <IconPlus />
            </button>
          </div>
        </div>
      ) : type === 'contacts' ? (
        <div className={styles.viewerContainer} onClick={onClick}>
          <div className={styles.viewerContainerHeader}>
            <div className={styles.viewerContainerAvatar}>

            </div>
            <div className={styles.viewerContainerInfo}>
              <b>
                {data.title || 'Nombre del contacto'}
              </b>
              <p>
                {data.text || 'Tipo de contacto'}
              </p>
              <span>
                {data.id || 'Número Fiscal'}
              </span>
              <span>
                {data.id || 'Email address, Zip code, etc.'}
              </span>
              <div className={styles.viewerContainerButtons}>
                <button>
                  <IconView />
                  Ver
                </button>
                <Tags items={items} />
              </div>
            </div>
          </div>
          <div className={styles.viewerContainerActions}>
            {viewMore && (
              <>
                <button>
                  <IconAttach />
                </button>
                <button>
                  <IconTag />
                </button>
                <button>
                  <IconWorld />
                </button>
              </>
            )}
            {!viewMore && (
              <>
                <button>
                  <IconView />
                </button>
                <button>
                  <IconPhone />
                </button>
                <button>
                  <IconEmail />
                </button>
              </>
            )}
            <button className={styles.second}>
              <IconEdit />
            </button>
            <button
              className={styles.second}
              onClick={onViewMore}
            >
              <IconPlus />
            </button>
          </div>
        </div>
      ) : type === 'agents' ? (
        <div className={styles.viewerContainer} onClick={onClick}>
          <div className={styles.viewerContainerHeader}>

            <div className={styles.viewerContainerAvatar}>
              <IconAgent />
            </div>
            <div className={styles.viewerContainerInfo}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <b>
                  Nombre del agente
                </b>
                <div className={styles.viewerContainerLabel}>
                  <div>
                    5 Resp.
                    <IconClock />
                  </div>
                  <div>
                    5
                    <IconAutomate />
                  </div>
                </div>
              </div>
              <span>
                Publico, privado, clave: *** asd
              </span>
              <span>
                Descripción del agente
              </span>
              <Tags items={items} />

              <div className={styles.viewerContainerLabelBottom}>
                FacturaGPT
                <IconStar />
                <IconField />
                <span>
                  Hace un año
                </span>
              </div>
            </div>
          </div>
          <div className={styles.viewerContainerActions}>

            {!viewMore && (
              <>
                <button>
                  <IconAgent />
                </button>
                <button>
                  <IconChat />
                </button>
                <button>
                  <IconShare />
                </button>
              </>
            )}
            <button className={styles.second}>
              <IconEdit />
            </button>
            <button
              className={styles.second}
              onClick={onViewMore}
            >
              <IconPlus />
            </button>
          </div>
        </div>
      ) : null}

    </div>
  );
};